import * as Apollo from '@apollo/client';
import { ApolloError, Observable, ApolloClient, makeVar, useReactiveVar, InMemoryCache } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';
import { invariant, CausedError, assertError, erc20, ChainType, Amount, never, DateUtils, assertJustOne, isNonNullable, hasTwoOrMore, hasAtLeastOne } from '@lens-protocol/shared-kernel';
import gql from 'graphql-tag';
import { FollowPolicyType } from '@lens-protocol/domain/use-cases/profile';
import { ReactionType, TransactionKind, TransactionError, TransactionErrorReason, DecryptionCriteriaType, NftContractType } from '@lens-protocol/domain/entities';
import { CollectType, CollectPolicyType, ReferencePolicyType } from '@lens-protocol/domain/use-cases/publications';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function assertGraphQLClientQueryResult(result, operationName) {
  invariant(result.data, "No data received for query: ".concat(operationName, "}"));
}
function assertGraphQLClientMutationResult(result, operationName) {
  invariant(result.data, "No data received for mutation: ".concat(operationName, "}}"));
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var UnspecifiedError = /*#__PURE__*/function (_CausedError) {
  _inherits(UnspecifiedError, _CausedError);
  var _super = _createSuper(UnspecifiedError);
  function UnspecifiedError(cause) {
    var _this;
    _classCallCheck(this, UnspecifiedError);
    _this = _super.call(this, cause.message, {
      cause: cause
    });
    _defineProperty(_assertThisInitialized(_this), "name", 'UnspecifiedError');
    return _this;
  }
  return _createClass(UnspecifiedError);
}(CausedError);
var ValidationError = /*#__PURE__*/function (_CausedError2) {
  _inherits(ValidationError, _CausedError2);
  var _super2 = _createSuper(ValidationError);
  function ValidationError(cause) {
    var _this2;
    _classCallCheck(this, ValidationError);
    _this2 = _super2.call(this, 'A validation error occurred', {
      cause: cause
    });
    _defineProperty(_assertThisInitialized(_this2), "name", 'ValidationError');
    return _this2;
  }
  return _createClass(ValidationError);
}(CausedError);

var ApolloServerErrorCode;
(function (ApolloServerErrorCode) {
  ApolloServerErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  ApolloServerErrorCode["GRAPHQL_PARSE_FAILED"] = "GRAPHQL_PARSE_FAILED";
  ApolloServerErrorCode["GRAPHQL_VALIDATION_FAILED"] = "GRAPHQL_VALIDATION_FAILED";
  ApolloServerErrorCode["PERSISTED_QUERY_NOT_FOUND"] = "PERSISTED_QUERY_NOT_FOUND";
  ApolloServerErrorCode["PERSISTED_QUERY_NOT_SUPPORTED"] = "PERSISTED_QUERY_NOT_SUPPORTED";
  ApolloServerErrorCode["BAD_USER_INPUT"] = "BAD_USER_INPUT";
  ApolloServerErrorCode["OPERATION_RESOLUTION_FAILURE"] = "OPERATION_RESOLUTION_FAILURE";
  ApolloServerErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
})(ApolloServerErrorCode || (ApolloServerErrorCode = {}));
function isGraphQLValidationError(e) {
  if (e instanceof ApolloError) {
    if (e.graphQLErrors[0] && e.graphQLErrors[0].extensions && e.graphQLErrors[0].extensions.code === ApolloServerErrorCode.GRAPHQL_VALIDATION_FAILED) {
      return true;
    }
  }
  return false;
}

var defaultPollingInterval = 3000;
function resolveError(error) {
  assertError(error);
  if (isGraphQLValidationError(error)) {
    return new ValidationError(error);
  }
  return new UnspecifiedError(error);
}
var LensApolloClient = /*#__PURE__*/function (_ref) {
  _inherits(LensApolloClient, _ref);
  var _super = _createSuper(LensApolloClient);
  function LensApolloClient(_ref2) {
    var _this;
    var cache = _ref2.cache,
      link = _ref2.link,
      _ref2$pollingInterval = _ref2.pollingInterval,
      pollingInterval = _ref2$pollingInterval === void 0 ? defaultPollingInterval : _ref2$pollingInterval;
    _classCallCheck(this, LensApolloClient);
    _this = _super.call(this, {
      cache: cache,
      defaultOptions: {
        query: {
          errorPolicy: 'none'
        },
        mutate: {
          errorPolicy: 'none'
        },
        watchQuery: {
          errorPolicy: 'none'
        }
      },
      link: link
    });
    _this.pollingInterval = pollingInterval;
    return _this;
  }
  _createClass(LensApolloClient, [{
    key: "query",
    value: function () {
      var _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        var _getOperationName, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _get(_getPrototypeOf(LensApolloClient.prototype), "query", this).call(this, options);
            case 3:
              result = _context.sent;
              assertGraphQLClientQueryResult(result, (_getOperationName = getOperationName(options.query)) !== null && _getOperationName !== void 0 ? _getOperationName : 'unknown');
              return _context.abrupt("return", result);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              throw resolveError(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 8]]);
      }));
      function query(_x) {
        return _query.apply(this, arguments);
      }
      return query;
    }()
  }, {
    key: "mutate",
    value: function () {
      var _mutate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        var _getOperationName2, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _get(_getPrototypeOf(LensApolloClient.prototype), "mutate", this).call(this, options);
            case 3:
              result = _context2.sent;
              assertGraphQLClientMutationResult(result, (_getOperationName2 = getOperationName(options.mutation)) !== null && _getOperationName2 !== void 0 ? _getOperationName2 : 'unknown');
              return _context2.abrupt("return", result);
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              throw resolveError(_context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function mutate(_x2) {
        return _mutate.apply(this, arguments);
      }
      return mutate;
    }()
  }, {
    key: "poll",
    value: function poll(options) {
      var observable = _get(_getPrototypeOf(LensApolloClient.prototype), "watchQuery", this).call(this, options);
      observable.startPolling(this.pollingInterval);
      return new Observable(function (observer) {
        return observable.subscribe({
          next: function next(_ref3) {
            var data = _ref3.data;
            observer.next(data);
          },
          error: function error(err) {
            observer.error(resolveError(err));
          },
          complete: function complete() {
            observer.complete();
          }
        });
      });
    }
  }]);
  return LensApolloClient;
}(ApolloClient);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131;
var defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

/** The claim status */
var ClaimStatus;
(function (ClaimStatus) {
  ClaimStatus["AlreadyClaimed"] = "ALREADY_CLAIMED";
  ClaimStatus["ClaimFailed"] = "CLAIM_FAILED";
  ClaimStatus["NotClaimed"] = "NOT_CLAIMED";
})(ClaimStatus || (ClaimStatus = {}));
/** The collect module types */
var CollectModules;
(function (CollectModules) {
  CollectModules["AaveFeeCollectModule"] = "AaveFeeCollectModule";
  CollectModules["Erc4626FeeCollectModule"] = "ERC4626FeeCollectModule";
  CollectModules["FeeCollectModule"] = "FeeCollectModule";
  CollectModules["FreeCollectModule"] = "FreeCollectModule";
  CollectModules["LimitedFeeCollectModule"] = "LimitedFeeCollectModule";
  CollectModules["LimitedTimedFeeCollectModule"] = "LimitedTimedFeeCollectModule";
  CollectModules["MultirecipientFeeCollectModule"] = "MultirecipientFeeCollectModule";
  CollectModules["RevertCollectModule"] = "RevertCollectModule";
  CollectModules["TimedFeeCollectModule"] = "TimedFeeCollectModule";
  CollectModules["UnknownCollectModule"] = "UnknownCollectModule";
})(CollectModules || (CollectModules = {}));
/** The comment ordering types */
var CommentOrderingTypes;

/** The comment ranking filter types */
(function (CommentOrderingTypes) {
  CommentOrderingTypes["Desc"] = "DESC";
  CommentOrderingTypes["Ranking"] = "RANKING";
})(CommentOrderingTypes || (CommentOrderingTypes = {}));
var CommentRankingFilter;

/** The gated publication access criteria contract types */
(function (CommentRankingFilter) {
  CommentRankingFilter["NoneRelevant"] = "NONE_RELEVANT";
  CommentRankingFilter["Relevant"] = "RELEVANT";
})(CommentRankingFilter || (CommentRankingFilter = {}));
var ContractType;

/** The create burn eip 712 typed data */
(function (ContractType) {
  ContractType["Erc20"] = "ERC20";
  ContractType["Erc721"] = "ERC721";
  ContractType["Erc1155"] = "ERC1155";
})(ContractType || (ContractType = {}));
/** The custom filters types */
var CustomFiltersTypes;

/** The reason why a profile cannot decrypt a publication */
(function (CustomFiltersTypes) {
  CustomFiltersTypes["Gardeners"] = "GARDENERS";
})(CustomFiltersTypes || (CustomFiltersTypes = {}));
var DecryptFailReason;
(function (DecryptFailReason) {
  DecryptFailReason["CanNotDecrypt"] = "CAN_NOT_DECRYPT";
  DecryptFailReason["CollectNotFinalisedOnChain"] = "COLLECT_NOT_FINALISED_ON_CHAIN";
  DecryptFailReason["DoesNotFollowProfile"] = "DOES_NOT_FOLLOW_PROFILE";
  DecryptFailReason["DoesNotOwnNft"] = "DOES_NOT_OWN_NFT";
  DecryptFailReason["DoesNotOwnProfile"] = "DOES_NOT_OWN_PROFILE";
  DecryptFailReason["FollowNotFinalisedOnChain"] = "FOLLOW_NOT_FINALISED_ON_CHAIN";
  DecryptFailReason["HasNotCollectedPublication"] = "HAS_NOT_COLLECTED_PUBLICATION";
  DecryptFailReason["MissingEncryptionParams"] = "MISSING_ENCRYPTION_PARAMS";
  DecryptFailReason["ProfileDoesNotExist"] = "PROFILE_DOES_NOT_EXIST";
  DecryptFailReason["UnauthorizedAddress"] = "UNAUTHORIZED_ADDRESS";
  DecryptFailReason["UnauthorizedBalance"] = "UNAUTHORIZED_BALANCE";
})(DecryptFailReason || (DecryptFailReason = {}));
/** The gated publication encryption provider */
var EncryptionProvider;
(function (EncryptionProvider) {
  EncryptionProvider["LitProtocol"] = "LIT_PROTOCOL";
})(EncryptionProvider || (EncryptionProvider = {}));
/** The feed event item filter types */
var FeedEventItemType;
(function (FeedEventItemType) {
  FeedEventItemType["CollectComment"] = "COLLECT_COMMENT";
  FeedEventItemType["CollectPost"] = "COLLECT_POST";
  FeedEventItemType["Comment"] = "COMMENT";
  FeedEventItemType["Mirror"] = "MIRROR";
  FeedEventItemType["Post"] = "POST";
  FeedEventItemType["ReactionComment"] = "REACTION_COMMENT";
  FeedEventItemType["ReactionPost"] = "REACTION_POST";
})(FeedEventItemType || (FeedEventItemType = {}));
/** The follow module types */
var FollowModules;
(function (FollowModules) {
  FollowModules["FeeFollowModule"] = "FeeFollowModule";
  FollowModules["ProfileFollowModule"] = "ProfileFollowModule";
  FollowModules["RevertFollowModule"] = "RevertFollowModule";
  FollowModules["UnknownFollowModule"] = "UnknownFollowModule";
})(FollowModules || (FollowModules = {}));
/** The verify webhook result status type */
var IdKitPhoneVerifyWebhookResultStatusType;
(function (IdKitPhoneVerifyWebhookResultStatusType) {
  IdKitPhoneVerifyWebhookResultStatusType["AlreadyVerified"] = "ALREADY_VERIFIED";
  IdKitPhoneVerifyWebhookResultStatusType["Success"] = "SUCCESS";
})(IdKitPhoneVerifyWebhookResultStatusType || (IdKitPhoneVerifyWebhookResultStatusType = {}));
/** The notification filter types */
var NotificationTypes;
(function (NotificationTypes) {
  NotificationTypes["CollectedComment"] = "COLLECTED_COMMENT";
  NotificationTypes["CollectedPost"] = "COLLECTED_POST";
  NotificationTypes["CommentedComment"] = "COMMENTED_COMMENT";
  NotificationTypes["CommentedPost"] = "COMMENTED_POST";
  NotificationTypes["Followed"] = "FOLLOWED";
  NotificationTypes["MentionComment"] = "MENTION_COMMENT";
  NotificationTypes["MentionPost"] = "MENTION_POST";
  NotificationTypes["MirroredComment"] = "MIRRORED_COMMENT";
  NotificationTypes["MirroredPost"] = "MIRRORED_POST";
  NotificationTypes["ReactionComment"] = "REACTION_COMMENT";
  NotificationTypes["ReactionPost"] = "REACTION_POST";
})(NotificationTypes || (NotificationTypes = {}));
/** profile sort criteria */
var ProfileSortCriteria;

/** The Profile Stats */
(function (ProfileSortCriteria) {
  ProfileSortCriteria["CreatedOn"] = "CREATED_ON";
  ProfileSortCriteria["LatestCreated"] = "LATEST_CREATED";
  ProfileSortCriteria["MostCollects"] = "MOST_COLLECTS";
  ProfileSortCriteria["MostComments"] = "MOST_COMMENTS";
  ProfileSortCriteria["MostFollowers"] = "MOST_FOLLOWERS";
  ProfileSortCriteria["MostMirrors"] = "MOST_MIRRORS";
  ProfileSortCriteria["MostPosts"] = "MOST_POSTS";
  ProfileSortCriteria["MostPublication"] = "MOST_PUBLICATION";
})(ProfileSortCriteria || (ProfileSortCriteria = {}));
/** The proxy action status */
var ProxyActionStatusTypes;
(function (ProxyActionStatusTypes) {
  ProxyActionStatusTypes["Complete"] = "COMPLETE";
  ProxyActionStatusTypes["Minting"] = "MINTING";
  ProxyActionStatusTypes["Transferring"] = "TRANSFERRING";
})(ProxyActionStatusTypes || (ProxyActionStatusTypes = {}));
/** The publication content warning */
var PublicationContentWarning;
(function (PublicationContentWarning) {
  PublicationContentWarning["Nsfw"] = "NSFW";
  PublicationContentWarning["Sensitive"] = "SENSITIVE";
  PublicationContentWarning["Spoiler"] = "SPOILER";
})(PublicationContentWarning || (PublicationContentWarning = {}));
/** The publication main focus */
var PublicationMainFocus;

/** The source of the media */
(function (PublicationMainFocus) {
  PublicationMainFocus["Article"] = "ARTICLE";
  PublicationMainFocus["Audio"] = "AUDIO";
  PublicationMainFocus["Embed"] = "EMBED";
  PublicationMainFocus["Image"] = "IMAGE";
  PublicationMainFocus["Link"] = "LINK";
  PublicationMainFocus["TextOnly"] = "TEXT_ONLY";
  PublicationMainFocus["Video"] = "VIDEO";
})(PublicationMainFocus || (PublicationMainFocus = {}));
var PublicationMediaSource;

/** Publication metadata content warning filters */
(function (PublicationMediaSource) {
  PublicationMediaSource["Lens"] = "LENS";
})(PublicationMediaSource || (PublicationMediaSource = {}));
/** The publication metadata display types */
var PublicationMetadataDisplayTypes;

/** Publication metadata filters */
(function (PublicationMetadataDisplayTypes) {
  PublicationMetadataDisplayTypes["Date"] = "date";
  PublicationMetadataDisplayTypes["Number"] = "number";
  PublicationMetadataDisplayTypes["String"] = "string";
})(PublicationMetadataDisplayTypes || (PublicationMetadataDisplayTypes = {}));
/** publication metadata status type */
var PublicationMetadataStatusType;

/** Publication metadata tag filter */
(function (PublicationMetadataStatusType) {
  PublicationMetadataStatusType["MetadataValidationFailed"] = "METADATA_VALIDATION_FAILED";
  PublicationMetadataStatusType["NotFound"] = "NOT_FOUND";
  PublicationMetadataStatusType["Pending"] = "PENDING";
  PublicationMetadataStatusType["Success"] = "SUCCESS";
})(PublicationMetadataStatusType || (PublicationMetadataStatusType = {}));
/** Publication reporting fraud subreason */
var PublicationReportingFraudSubreason;

/** Publication reporting illegal subreason */
(function (PublicationReportingFraudSubreason) {
  PublicationReportingFraudSubreason["Impersonation"] = "IMPERSONATION";
  PublicationReportingFraudSubreason["Scam"] = "SCAM";
})(PublicationReportingFraudSubreason || (PublicationReportingFraudSubreason = {}));
var PublicationReportingIllegalSubreason;

/** Publication reporting reason */
(function (PublicationReportingIllegalSubreason) {
  PublicationReportingIllegalSubreason["AnimalAbuse"] = "ANIMAL_ABUSE";
  PublicationReportingIllegalSubreason["DirectThreat"] = "DIRECT_THREAT";
  PublicationReportingIllegalSubreason["HumanAbuse"] = "HUMAN_ABUSE";
  PublicationReportingIllegalSubreason["ThreatIndividual"] = "THREAT_INDIVIDUAL";
  PublicationReportingIllegalSubreason["Violence"] = "VIOLENCE";
})(PublicationReportingIllegalSubreason || (PublicationReportingIllegalSubreason = {}));
var PublicationReportingReason;

/** Publication reporting sensitive subreason */
(function (PublicationReportingReason) {
  PublicationReportingReason["Fraud"] = "FRAUD";
  PublicationReportingReason["Illegal"] = "ILLEGAL";
  PublicationReportingReason["Sensitive"] = "SENSITIVE";
  PublicationReportingReason["Spam"] = "SPAM";
})(PublicationReportingReason || (PublicationReportingReason = {}));
var PublicationReportingSensitiveSubreason;

/** Publication reporting spam subreason */
(function (PublicationReportingSensitiveSubreason) {
  PublicationReportingSensitiveSubreason["Nsfw"] = "NSFW";
  PublicationReportingSensitiveSubreason["Offensive"] = "OFFENSIVE";
})(PublicationReportingSensitiveSubreason || (PublicationReportingSensitiveSubreason = {}));
var PublicationReportingSpamSubreason;

/** The social comment */
(function (PublicationReportingSpamSubreason) {
  PublicationReportingSpamSubreason["FakeEngagement"] = "FAKE_ENGAGEMENT";
  PublicationReportingSpamSubreason["ManipulationAlgo"] = "MANIPULATION_ALGO";
  PublicationReportingSpamSubreason["Misleading"] = "MISLEADING";
  PublicationReportingSpamSubreason["MisuseHashtags"] = "MISUSE_HASHTAGS";
  PublicationReportingSpamSubreason["Repetitive"] = "REPETITIVE";
  PublicationReportingSpamSubreason["SomethingElse"] = "SOMETHING_ELSE";
  PublicationReportingSpamSubreason["Unrelated"] = "UNRELATED";
})(PublicationReportingSpamSubreason || (PublicationReportingSpamSubreason = {}));
/** Publication sort criteria */
var PublicationSortCriteria;

/** The publication stats */
(function (PublicationSortCriteria) {
  PublicationSortCriteria["CuratedProfiles"] = "CURATED_PROFILES";
  PublicationSortCriteria["Latest"] = "LATEST";
  PublicationSortCriteria["TopCollected"] = "TOP_COLLECTED";
  PublicationSortCriteria["TopCommented"] = "TOP_COMMENTED";
  PublicationSortCriteria["TopMirrored"] = "TOP_MIRRORED";
})(PublicationSortCriteria || (PublicationSortCriteria = {}));
/** The publication types */
var PublicationTypes;
(function (PublicationTypes) {
  PublicationTypes["Comment"] = "COMMENT";
  PublicationTypes["Mirror"] = "MIRROR";
  PublicationTypes["Post"] = "POST";
})(PublicationTypes || (PublicationTypes = {}));
/** Reaction types */
var ReactionTypes;
(function (ReactionTypes) {
  ReactionTypes["Downvote"] = "DOWNVOTE";
  ReactionTypes["Upvote"] = "UPVOTE";
})(ReactionTypes || (ReactionTypes = {}));
/** The reference module types */
var ReferenceModules;

/** The refresh request */
(function (ReferenceModules) {
  ReferenceModules["DegreesOfSeparationReferenceModule"] = "DegreesOfSeparationReferenceModule";
  ReferenceModules["FollowerOnlyReferenceModule"] = "FollowerOnlyReferenceModule";
  ReferenceModules["UnknownReferenceModule"] = "UnknownReferenceModule";
})(ReferenceModules || (ReferenceModules = {}));
/** Relay error reason */
var RelayErrorReasons;
(function (RelayErrorReasons) {
  RelayErrorReasons["Expired"] = "EXPIRED";
  RelayErrorReasons["HandleTaken"] = "HANDLE_TAKEN";
  RelayErrorReasons["NotAllowed"] = "NOT_ALLOWED";
  RelayErrorReasons["Rejected"] = "REJECTED";
  RelayErrorReasons["WrongWalletSigned"] = "WRONG_WALLET_SIGNED";
})(RelayErrorReasons || (RelayErrorReasons = {}));
/** The gated publication access criteria scalar operators */
var ScalarOperator;
(function (ScalarOperator) {
  ScalarOperator["Equal"] = "EQUAL";
  ScalarOperator["GreaterThan"] = "GREATER_THAN";
  ScalarOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
  ScalarOperator["LessThan"] = "LESS_THAN";
  ScalarOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
  ScalarOperator["NotEqual"] = "NOT_EQUAL";
})(ScalarOperator || (ScalarOperator = {}));
/** Search request types */
var SearchRequestTypes;
(function (SearchRequestTypes) {
  SearchRequestTypes["Profile"] = "PROFILE";
  SearchRequestTypes["Publication"] = "PUBLICATION";
})(SearchRequestTypes || (SearchRequestTypes = {}));
/** The publications tags sort criteria */
var TagSortCriteria;
(function (TagSortCriteria) {
  TagSortCriteria["Alphabetical"] = "ALPHABETICAL";
  TagSortCriteria["MostPopular"] = "MOST_POPULAR";
})(TagSortCriteria || (TagSortCriteria = {}));
/** Transaction error reason */
var TransactionErrorReasons;
(function (TransactionErrorReasons) {
  TransactionErrorReasons["Reverted"] = "REVERTED";
})(TransactionErrorReasons || (TransactionErrorReasons = {}));
/** The worldcoin signal type */
var WorldcoinPhoneVerifyType;
(function (WorldcoinPhoneVerifyType) {
  WorldcoinPhoneVerifyType["Orb"] = "ORB";
  WorldcoinPhoneVerifyType["Phone"] = "PHONE";
})(WorldcoinPhoneVerifyType || (WorldcoinPhoneVerifyType = {}));
var PublicationStatsFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment PublicationStats on PublicationStats {\n    __typename\n    totalAmountOfMirrors\n    totalUpvotes\n    totalDownvotes\n    totalAmountOfCollects\n    totalAmountOfComments\n    commentsCount: commentsTotal(forSources: $sources)\n  }\n"])));
var MediaFragmentDoc = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fragment Media on Media {\n    __typename\n    altTag\n    cover\n    mimeType\n    url\n  }\n"])));
var MediaSetFragmentDoc = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fragment MediaSet on MediaSet {\n    __typename\n    original {\n      ...Media\n    }\n  }\n  ", "\n"])), MediaFragmentDoc);
var MetadataAttributeOutputFragmentDoc = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fragment MetadataAttributeOutput on MetadataAttributeOutput {\n    __typename\n    traitType\n    value\n  }\n"])));
var NftOwnershipFragmentDoc = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  fragment NftOwnership on NftOwnershipOutput {\n    __typename\n    contractAddress\n    chainID\n    contractType\n    tokenIds\n  }\n"])));
var Erc20OwnershipFragmentDoc = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  fragment Erc20Ownership on Erc20OwnershipOutput {\n    __typename\n    amount\n    chainID\n    condition\n    contractAddress\n    decimals\n    name\n    symbol\n  }\n"])));
var AddressOwnershipFragmentDoc = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  fragment AddressOwnership on EoaOwnershipOutput {\n    __typename\n    address\n  }\n"])));
var ProfileOwnershipFragmentDoc = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  fragment ProfileOwnership on ProfileOwnershipOutput {\n    __typename\n    profileId\n  }\n"])));
var FollowConditionFragmentDoc = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  fragment FollowCondition on FollowConditionOutput {\n    __typename\n    profileId\n  }\n"])));
var CollectConditionFragmentDoc = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  fragment CollectCondition on CollectConditionOutput {\n    __typename\n    publicationId\n    thisPublication\n  }\n"])));
var LeafConditionFragmentDoc = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  fragment LeafCondition on AccessConditionOutput {\n    __typename\n    nft {\n      ...NftOwnership\n    }\n    token {\n      ...Erc20Ownership\n    }\n    eoa {\n      ...AddressOwnership\n    }\n    profile {\n      ...ProfileOwnership\n    }\n    follow {\n      ...FollowCondition\n    }\n    collect {\n      ...CollectCondition\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), NftOwnershipFragmentDoc, Erc20OwnershipFragmentDoc, AddressOwnershipFragmentDoc, ProfileOwnershipFragmentDoc, FollowConditionFragmentDoc, CollectConditionFragmentDoc);
var OrConditionFragmentDoc = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  fragment OrCondition on OrConditionOutput {\n    __typename\n    criteria {\n      ...LeafCondition\n    }\n  }\n  ", "\n"])), LeafConditionFragmentDoc);
var AndConditionFragmentDoc = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  fragment AndCondition on AndConditionOutput {\n    __typename\n    criteria {\n      ...LeafCondition\n    }\n  }\n  ", "\n"])), LeafConditionFragmentDoc);
var AnyConditionFragmentDoc = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  fragment AnyCondition on AccessConditionOutput {\n    __typename\n    ...LeafCondition\n    or {\n      ...OrCondition\n    }\n    and {\n      ...AndCondition\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), LeafConditionFragmentDoc, OrConditionFragmentDoc, AndConditionFragmentDoc);
var RootConditionFragmentDoc = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  fragment RootCondition on AccessConditionOutput {\n    __typename\n    or {\n      criteria {\n        ...AnyCondition\n      }\n    }\n  }\n  ", "\n"])), AnyConditionFragmentDoc);
var EncryptedMediaFragmentDoc = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  fragment EncryptedMedia on EncryptedMedia {\n    __typename\n    altTag\n    cover\n    mimeType\n    url\n  }\n"])));
var EncryptedFieldsFragmentDoc = gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  fragment EncryptedFields on EncryptedFieldsOutput {\n    __typename\n    animation_url\n    content\n    external_url\n    image\n    media {\n      original {\n        ...EncryptedMedia\n      }\n    }\n  }\n  ", "\n"])), EncryptedMediaFragmentDoc);
var EncryptionParamsFragmentDoc = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  fragment EncryptionParams on EncryptionParamsOutput {\n    __typename\n    accessCondition {\n      ...RootCondition\n    }\n    encryptionProvider\n    encryptedFields {\n      ...EncryptedFields\n    }\n    providerSpecificParams {\n      encryptionKey\n    }\n  }\n  ", "\n  ", "\n"])), RootConditionFragmentDoc, EncryptedFieldsFragmentDoc);
var MetadataFragmentDoc = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  fragment Metadata on MetadataOutput {\n    __typename\n    animatedUrl\n    name\n    description\n    mainContentFocus\n    content\n    image\n    media {\n      ...MediaSet\n    }\n    attributes {\n      ...MetadataAttributeOutput\n    }\n    __encryptionParams: encryptionParams {\n      ...EncryptionParams\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), MediaSetFragmentDoc, MetadataAttributeOutputFragmentDoc, EncryptionParamsFragmentDoc);
var ProfileMediaFragmentDoc = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  fragment ProfileMedia on ProfileMedia {\n    ... on NftImage {\n      __typename\n      contractAddress\n      tokenId\n      uri\n      verified\n    }\n    ... on MediaSet {\n      ...MediaSet\n    }\n  }\n  ", "\n"])), MediaSetFragmentDoc);
var ProfileStatsFragmentDoc = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  fragment ProfileStats on ProfileStats {\n    __typename\n    totalCollects\n    totalComments\n    totalFollowers\n    totalFollowing\n    totalMirrors\n    totalPosts\n    totalPublications\n    commentsCount: commentsTotal(forSources: $sources)\n    postsCount: postsTotal(forSources: $sources)\n    mirrorsCount: mirrorsTotal(forSources: $sources)\n  }\n"])));
var Erc20FragmentDoc = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  fragment Erc20 on Erc20 {\n    __typename\n    name\n    symbol\n    decimals\n    address\n  }\n"])));
var ModuleFeeAmountFragmentDoc = gql(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  fragment ModuleFeeAmount on ModuleFeeAmount {\n    __typename\n    asset {\n      ...Erc20\n    }\n    value\n  }\n  ", "\n"])), Erc20FragmentDoc);
var FeeFollowModuleSettingsFragmentDoc = gql(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  fragment FeeFollowModuleSettings on FeeFollowModuleSettings {\n    __typename\n    amount {\n      ...ModuleFeeAmount\n    }\n    contractAddress\n    recipient\n  }\n  ", "\n"])), ModuleFeeAmountFragmentDoc);
var ProfileFollowModuleSettingsFragmentDoc = gql(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  fragment ProfileFollowModuleSettings on ProfileFollowModuleSettings {\n    __typename\n    contractAddress\n  }\n"])));
var RevertFollowModuleSettingsFragmentDoc = gql(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  fragment RevertFollowModuleSettings on RevertFollowModuleSettings {\n    __typename\n    contractAddress\n  }\n"])));
var UnknownFollowModuleSettingsFragmentDoc = gql(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  fragment UnknownFollowModuleSettings on UnknownFollowModuleSettings {\n    __typename\n    contractAddress\n  }\n"])));
var AttributeFragmentDoc = gql(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  fragment Attribute on Attribute {\n    __typename\n    displayType\n    key\n    value\n  }\n"])));
var ProfileFragmentDoc = gql(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  fragment Profile on Profile {\n    __typename\n    id\n    name\n    bio\n    handle\n    ownedBy\n    picture {\n      ...ProfileMedia\n    }\n    coverPicture {\n      ...ProfileMedia\n    }\n    stats {\n      ...ProfileStats\n    }\n    __followModule: followModule {\n      ... on FeeFollowModuleSettings {\n        ...FeeFollowModuleSettings\n      }\n      ... on ProfileFollowModuleSettings {\n        ...ProfileFollowModuleSettings\n      }\n      ... on RevertFollowModuleSettings {\n        ...RevertFollowModuleSettings\n      }\n      ... on UnknownFollowModuleSettings {\n        ...UnknownFollowModuleSettings\n      }\n    }\n    followPolicy @client\n    __attributes: attributes {\n      ...Attribute\n    }\n    attributes: attributesMap @client\n    dispatcher {\n      address\n      canUseRelay\n    }\n    onChainIdentity {\n      proofOfHumanity\n      ens {\n        name\n      }\n      sybilDotOrg {\n        verified\n        source {\n          twitter {\n            handle\n          }\n        }\n      }\n      worldcoin {\n        isHuman\n      }\n    }\n    __isFollowedByMe: isFollowedByMe\n    isFollowingObserver: isFollowing(who: $observerId)\n    followStatus @client\n    ownedByMe @client\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ProfileMediaFragmentDoc, ProfileStatsFragmentDoc, FeeFollowModuleSettingsFragmentDoc, ProfileFollowModuleSettingsFragmentDoc, RevertFollowModuleSettingsFragmentDoc, UnknownFollowModuleSettingsFragmentDoc, AttributeFragmentDoc);
var WalletFragmentDoc = gql(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  fragment Wallet on Wallet {\n    __typename\n    address\n    defaultProfile {\n      ...Profile\n    }\n  }\n  ", "\n"])), ProfileFragmentDoc);
var FreeCollectModuleSettingsFragmentDoc = gql(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  fragment FreeCollectModuleSettings on FreeCollectModuleSettings {\n    __typename\n    contractAddress\n    followerOnly\n  }\n"])));
var FeeCollectModuleSettingsFragmentDoc = gql(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  fragment FeeCollectModuleSettings on FeeCollectModuleSettings {\n    __typename\n    amount {\n      ...ModuleFeeAmount\n    }\n    contractAddress\n    followerOnly\n    recipient\n    referralFee\n  }\n  ", "\n"])), ModuleFeeAmountFragmentDoc);
var LimitedFeeCollectModuleSettingsFragmentDoc = gql(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  fragment LimitedFeeCollectModuleSettings on LimitedFeeCollectModuleSettings {\n    __typename\n    amount {\n      ...ModuleFeeAmount\n    }\n    collectLimit\n    contractAddress\n    followerOnly\n    recipient\n    referralFee\n  }\n  ", "\n"])), ModuleFeeAmountFragmentDoc);
var LimitedTimedFeeCollectModuleSettingsFragmentDoc = gql(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  fragment LimitedTimedFeeCollectModuleSettings on LimitedTimedFeeCollectModuleSettings {\n    __typename\n    amount {\n      ...ModuleFeeAmount\n    }\n    collectLimit\n    contractAddress\n    followerOnly\n    endTimestamp\n    recipient\n    referralFee\n  }\n  ", "\n"])), ModuleFeeAmountFragmentDoc);
var RevertCollectModuleSettingsFragmentDoc = gql(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  fragment RevertCollectModuleSettings on RevertCollectModuleSettings {\n    __typename\n    contractAddress\n  }\n"])));
var TimedFeeCollectModuleSettingsFragmentDoc = gql(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  fragment TimedFeeCollectModuleSettings on TimedFeeCollectModuleSettings {\n    __typename\n    amount {\n      ...ModuleFeeAmount\n    }\n    contractAddress\n    followerOnly\n    endTimestamp\n    recipient\n    referralFee\n  }\n  ", "\n"])), ModuleFeeAmountFragmentDoc);
var CollectModuleFragmentDoc = gql(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  fragment CollectModule on CollectModule {\n    __typename\n    ... on FreeCollectModuleSettings {\n      ...FreeCollectModuleSettings\n    }\n    ... on FeeCollectModuleSettings {\n      ...FeeCollectModuleSettings\n    }\n    ... on LimitedFeeCollectModuleSettings {\n      ...LimitedFeeCollectModuleSettings\n    }\n    ... on LimitedTimedFeeCollectModuleSettings {\n      ...LimitedTimedFeeCollectModuleSettings\n    }\n    ... on RevertCollectModuleSettings {\n      ...RevertCollectModuleSettings\n    }\n    ... on TimedFeeCollectModuleSettings {\n      ...TimedFeeCollectModuleSettings\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), FreeCollectModuleSettingsFragmentDoc, FeeCollectModuleSettingsFragmentDoc, LimitedFeeCollectModuleSettingsFragmentDoc, LimitedTimedFeeCollectModuleSettingsFragmentDoc, RevertCollectModuleSettingsFragmentDoc, TimedFeeCollectModuleSettingsFragmentDoc);
var ReferenceModuleFragmentDoc = gql(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  fragment ReferenceModule on ReferenceModule {\n    __typename\n    ... on FollowOnlyReferenceModuleSettings {\n      contractAddress\n    }\n  }\n"])));
var CommentBaseFragmentDoc = gql(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  fragment CommentBase on Comment {\n    __typename\n    id\n    stats {\n      ...PublicationStats\n    }\n    metadata {\n      ...Metadata\n    }\n    profile {\n      ...Profile\n    }\n    collectedBy {\n      ...Wallet\n    }\n    __collectModule: collectModule {\n      ...CollectModule\n    }\n    referenceModule {\n      ...ReferenceModule\n    }\n    createdAt\n    hidden\n    isGated\n    reaction(request: { profileId: $observerId })\n    hasCollectedByMe(isFinalisedOnChain: true)\n    canComment(profileId: $observerId) {\n      result\n    }\n    canMirror(profileId: $observerId) {\n      result\n    }\n    canObserverDecrypt: canDecrypt(profileId: $observerId) {\n      result\n      reasons\n    }\n    mirrors(by: $observerId)\n    hasOptimisticCollectedByMe @client\n    isOptimisticMirroredByMe @client\n    collectPolicy @client\n    referencePolicy @client\n    decryptionCriteria @client\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PublicationStatsFragmentDoc, MetadataFragmentDoc, ProfileFragmentDoc, WalletFragmentDoc, CollectModuleFragmentDoc, ReferenceModuleFragmentDoc);
var PostFragmentDoc = gql(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  fragment Post on Post {\n    __typename\n    id\n    stats {\n      ...PublicationStats\n    }\n    metadata {\n      ...Metadata\n    }\n    profile {\n      ...Profile\n    }\n    collectedBy {\n      ...Wallet\n    }\n    __collectModule: collectModule {\n      ...CollectModule\n    }\n    referenceModule {\n      ...ReferenceModule\n    }\n    createdAt\n    hidden\n    isGated\n    reaction(request: { profileId: $observerId })\n    hasCollectedByMe(isFinalisedOnChain: true)\n    canComment(profileId: $observerId) {\n      result\n    }\n    canMirror(profileId: $observerId) {\n      result\n    }\n    mirrors(by: $observerId)\n    canObserverDecrypt: canDecrypt(profileId: $observerId) {\n      result\n      reasons\n    }\n    hasOptimisticCollectedByMe @client\n    isOptimisticMirroredByMe @client\n    collectPolicy @client\n    referencePolicy @client\n    decryptionCriteria @client\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PublicationStatsFragmentDoc, MetadataFragmentDoc, ProfileFragmentDoc, WalletFragmentDoc, CollectModuleFragmentDoc, ReferenceModuleFragmentDoc);
var MirrorBaseFragmentDoc = gql(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  fragment MirrorBase on Mirror {\n    __typename\n    id\n    createdAt\n    profile {\n      ...Profile\n    }\n    hidden\n  }\n  ", "\n"])), ProfileFragmentDoc);
var CommentFragmentDoc = gql(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  fragment Comment on Comment {\n    __typename\n    ...CommentBase\n    commentOn {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...MirrorBase\n      }\n      ... on Comment {\n        ...CommentBase\n      }\n    }\n    mainPost {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...MirrorBase\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), CommentBaseFragmentDoc, PostFragmentDoc, MirrorBaseFragmentDoc);
var CommentWithFirstCommentFragmentDoc = gql(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  fragment CommentWithFirstComment on Comment {\n    __typename\n    ...Comment\n    firstComment {\n      ...Comment\n    }\n  }\n  ", "\n"])), CommentFragmentDoc);
var CommonPaginatedResultInfoFragmentDoc = gql(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  fragment CommonPaginatedResultInfo on PaginatedResultInfo {\n    __typename\n    prev\n    next\n    totalCount\n  }\n"])));
var PendingPostFragmentDoc = gql(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  fragment PendingPost on PendingPost {\n    __typename\n    id\n    content\n    media {\n      ...Media\n    }\n    profile {\n      ...Profile\n    }\n    locale\n    mainContentFocus\n  }\n  ", "\n  ", "\n"])), MediaFragmentDoc, ProfileFragmentDoc);
var Eip712TypedDataDomainFragmentDoc = gql(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  fragment EIP712TypedDataDomain on EIP712TypedDataDomain {\n    __typename\n    name\n    chainId\n    version\n    verifyingContract\n  }\n"])));
var ElectedMirrorFragmentDoc = gql(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  fragment ElectedMirror on ElectedMirror {\n    __typename\n    mirrorId\n    profile {\n      ...Profile\n    }\n    timestamp\n  }\n  ", "\n"])), ProfileFragmentDoc);
var MirrorEventFragmentDoc = gql(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  fragment MirrorEvent on MirrorEvent {\n    __typename\n    profile {\n      ...Profile\n    }\n    timestamp\n  }\n  ", "\n"])), ProfileFragmentDoc);
var CollectedEventFragmentDoc = gql(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  fragment CollectedEvent on CollectedEvent {\n    __typename\n    profile {\n      ...Profile\n    }\n    timestamp\n  }\n  ", "\n"])), ProfileFragmentDoc);
var ReactionEventFragmentDoc = gql(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  fragment ReactionEvent on ReactionEvent {\n    __typename\n    profile {\n      ...Profile\n    }\n    reaction\n    timestamp\n  }\n  ", "\n"])), ProfileFragmentDoc);
var FeedItemFragmentDoc = gql(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  fragment FeedItem on FeedItem {\n    __typename\n    root {\n      ... on Post {\n        ...Post\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n    comments {\n      ...Comment\n    }\n    electedMirror {\n      ...ElectedMirror\n    }\n    mirrors {\n      ...MirrorEvent\n    }\n    collects {\n      ...CollectedEvent\n    }\n    reactions {\n      ...ReactionEvent\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, CommentFragmentDoc, ElectedMirrorFragmentDoc, MirrorEventFragmentDoc, CollectedEventFragmentDoc, ReactionEventFragmentDoc);
var EncryptedMediaSetFragmentDoc = gql(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  fragment EncryptedMediaSet on EncryptedMediaSet {\n    __typename\n    original {\n      ...EncryptedMedia\n    }\n  }\n  ", "\n"])), EncryptedMediaFragmentDoc);
var ModuleInfoFragmentDoc = gql(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  fragment ModuleInfo on ModuleInfo {\n    __typename\n    name\n    type\n  }\n"])));
var EnabledModuleFragmentDoc = gql(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  fragment EnabledModule on EnabledModule {\n    __typename\n    moduleName\n    contractAddress\n    inputParams {\n      ...ModuleInfo\n    }\n    redeemParams {\n      ...ModuleInfo\n    }\n    returnDataParams: returnDataParms {\n      ...ModuleInfo\n    }\n  }\n  ", "\n"])), ModuleInfoFragmentDoc);
var EnabledModulesFragmentDoc = gql(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  fragment EnabledModules on EnabledModules {\n    __typename\n    collectModules {\n      ...EnabledModule\n    }\n    followModules {\n      ...EnabledModule\n    }\n    referenceModules {\n      ...EnabledModule\n    }\n  }\n  ", "\n"])), EnabledModuleFragmentDoc);
var NewFollowerNotificationFragmentDoc = gql(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  fragment NewFollowerNotification on NewFollowerNotification {\n    __typename\n    notificationId\n    createdAt\n    isFollowedByMe\n    wallet {\n      ...Wallet\n    }\n  }\n  ", "\n"])), WalletFragmentDoc);
var MirrorFragmentDoc = gql(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  fragment Mirror on Mirror {\n    __typename\n    ...MirrorBase\n    mirrorOf {\n      ... on Post {\n        ...Post\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), MirrorBaseFragmentDoc, PostFragmentDoc, CommentFragmentDoc);
var NewCollectNotificationFragmentDoc = gql(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  fragment NewCollectNotification on NewCollectNotification {\n    __typename\n    notificationId\n    createdAt\n    wallet {\n      ...Wallet\n    }\n    collectedPublication {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...Mirror\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), WalletFragmentDoc, PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc);
var NewMirrorNotificationFragmentDoc = gql(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  fragment NewMirrorNotification on NewMirrorNotification {\n    __typename\n    notificationId\n    createdAt\n    profile {\n      ...Profile\n    }\n    publication {\n      ... on Post {\n        ...Post\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), ProfileFragmentDoc, PostFragmentDoc, CommentFragmentDoc);
var NewCommentNotificationFragmentDoc = gql(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  fragment NewCommentNotification on NewCommentNotification {\n    __typename\n    notificationId\n    createdAt\n    profile {\n      ...Profile\n    }\n    comment {\n      ...Comment\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommentFragmentDoc);
var NewMentionNotificationFragmentDoc = gql(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  fragment NewMentionNotification on NewMentionNotification {\n    __typename\n    notificationId\n    createdAt\n    mentionPublication {\n      ... on Post {\n        ...Post\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n  }\n  ", "\n  ", "\n"])), PostFragmentDoc, CommentFragmentDoc);
var NewReactionNotificationFragmentDoc = gql(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  fragment NewReactionNotification on NewReactionNotification {\n    __typename\n    notificationId\n    createdAt\n    profile {\n      ...Profile\n    }\n    reaction\n    publication {\n      ... on Post {\n        ...Post\n      }\n      ... on Comment {\n        ...Comment\n      }\n      ... on Mirror {\n        ...Mirror\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ProfileFragmentDoc, PostFragmentDoc, CommentFragmentDoc, MirrorFragmentDoc);
var FollowerFragmentDoc = gql(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  fragment Follower on Follower {\n    __typename\n    wallet {\n      ...Wallet\n    }\n  }\n  ", "\n"])), WalletFragmentDoc);
var FollowingFragmentDoc = gql(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  fragment Following on Following {\n    __typename\n    profile {\n      ...Profile\n    }\n  }\n  ", "\n"])), ProfileFragmentDoc);
var ProxyActionStatusResultFragmentDoc = gql(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  fragment ProxyActionStatusResult on ProxyActionStatusResult {\n    __typename\n    txHash\n    txId\n    status\n  }\n"])));
var ProxyActionErrorFragmentDoc = gql(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  fragment ProxyActionError on ProxyActionError {\n    __typename\n    reason\n    lastKnownTxId\n  }\n"])));
var ProxyActionQueuedFragmentDoc = gql(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  fragment ProxyActionQueued on ProxyActionQueued {\n    __typename\n    queuedAt\n  }\n"])));
var WhoReactedResultFragmentDoc = gql(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  fragment WhoReactedResult on WhoReactedResult {\n    __typename\n    reactionId\n    reaction\n    reactionAt\n    profile {\n      ...Profile\n    }\n  }\n  ", "\n"])), ProfileFragmentDoc);
var Erc20AmountFragmentDoc = gql(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  fragment Erc20Amount on Erc20Amount {\n    __typename\n    asset {\n      ...Erc20\n    }\n    value\n  }\n  ", "\n"])), Erc20FragmentDoc);
var RevenueAggregateFragmentDoc = gql(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  fragment RevenueAggregate on RevenueAggregate {\n    __typename\n    __total: total {\n      ...Erc20Amount\n    }\n    totalAmount @client\n  }\n  ", "\n"])), Erc20AmountFragmentDoc);
var PublicationRevenueFragmentDoc = gql(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  fragment PublicationRevenue on PublicationRevenue {\n    __typename\n    publication {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...Mirror\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n    revenue {\n      ...RevenueAggregate\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc, RevenueAggregateFragmentDoc);
var ProfileFollowRevenueFragmentDoc = gql(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  fragment ProfileFollowRevenue on FollowRevenueResult {\n    __typename\n    revenues {\n      ...RevenueAggregate\n    }\n  }\n  ", "\n"])), RevenueAggregateFragmentDoc);
var RelayerResultFragmentDoc = gql(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  fragment RelayerResult on RelayerResult {\n    __typename\n    txHash\n    txId\n  }\n"])));
var RelayErrorFragmentDoc = gql(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  fragment RelayError on RelayError {\n    __typename\n    reason\n  }\n"])));
var RelayResultFragmentDoc = gql(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n  fragment RelayResult on RelayResult {\n    ... on RelayerResult {\n      ...RelayerResult\n    }\n    ... on RelayError {\n      ...RelayError\n    }\n  }\n  ", "\n  ", "\n"])), RelayerResultFragmentDoc, RelayErrorFragmentDoc);
var TransactionIndexedResultFragmentDoc = gql(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  fragment TransactionIndexedResult on TransactionIndexedResult {\n    __typename\n    indexed\n    txHash\n  }\n"])));
var TransactionErrorFragmentDoc = gql(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  fragment TransactionError on TransactionError {\n    __typename\n    reason\n  }\n"])));
var AuthChallengeDocument = gql(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  query AuthChallenge($address: EthereumAddress!) {\n    result: challenge(request: { address: $address }) {\n      text\n    }\n  }\n"])));

/**
 * __useAuthChallengeQuery__
 *
 * To run a query within a React component, call `useAuthChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthChallengeQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
function useAuthChallengeQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(AuthChallengeDocument, options);
}
function useAuthChallengeLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(AuthChallengeDocument, options);
}
var AuthAuthenticateDocument = gql(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  mutation AuthAuthenticate($address: EthereumAddress!, $signature: Signature!) {\n    result: authenticate(request: { address: $address, signature: $signature }) {\n      accessToken\n      refreshToken\n    }\n  }\n"])));
/**
 * __useAuthAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authAuthenticateMutation, { data, loading, error }] = useAuthAuthenticateMutation({
 *   variables: {
 *      address: // value for 'address'
 *      signature: // value for 'signature'
 *   },
 * });
 */
function useAuthAuthenticateMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(AuthAuthenticateDocument, options);
}
var AuthRefreshDocument = gql(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  mutation AuthRefresh($refreshToken: Jwt!) {\n    result: refresh(request: { refreshToken: $refreshToken }) {\n      accessToken\n      refreshToken\n    }\n  }\n"])));
/**
 * __useAuthRefreshMutation__
 *
 * To run a mutation, you first call `useAuthRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshMutation, { data, loading, error }] = useAuthRefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
function useAuthRefreshMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(AuthRefreshDocument, options);
}
var CreateCollectTypedDataDocument = gql(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  mutation CreateCollectTypedData($request: CreateCollectRequest!, $options: TypedDataOptions) {\n    result: createCollectTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          CollectWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          pubId\n          data\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreateCollectTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateCollectTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectTypedDataMutation, { data, loading, error }] = useCreateCollectTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateCollectTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateCollectTypedDataDocument, options);
}
var CreateCommentTypedDataDocument = gql(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  mutation CreateCommentTypedData(\n    $request: CreatePublicCommentRequest!\n    $options: TypedDataOptions\n  ) {\n    result: createCommentTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          CommentWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          contentURI\n          profileIdPointed\n          pubIdPointed\n          collectModule\n          collectModuleInitData\n          referenceModuleData\n          referenceModule\n          referenceModuleInitData\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreateCommentTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateCommentTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentTypedDataMutation, { data, loading, error }] = useCreateCommentTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateCommentTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateCommentTypedDataDocument, options);
}
var CreateCommentViaDispatcherDocument = gql(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  mutation CreateCommentViaDispatcher($request: CreatePublicCommentRequest!) {\n    result: createCommentViaDispatcher(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreateCommentViaDispatcherMutation__
 *
 * To run a mutation, you first call `useCreateCommentViaDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentViaDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentViaDispatcherMutation, { data, loading, error }] = useCreateCommentViaDispatcherMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateCommentViaDispatcherMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateCommentViaDispatcherDocument, options);
}
var CommentsDocument = gql(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  query Comments(\n    $observerId: ProfileId\n    $commentsOf: InternalPublicationId!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n    $metadata: PublicationMetadataFilters\n  ) {\n    result: publications(\n      request: {\n        limit: $limit\n        cursor: $cursor\n        commentsOf: $commentsOf\n        sources: $sources\n        metadata: $metadata\n      }\n    ) {\n      items {\n        ... on Comment {\n          ...CommentWithFirstComment\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), CommentWithFirstCommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);
function useCommentsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(CommentsDocument, options);
}
var EnabledModuleCurrenciesDocument = gql(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n  query EnabledModuleCurrencies {\n    result: enabledModuleCurrencies {\n      ...Erc20\n    }\n  }\n  ", "\n"])), Erc20FragmentDoc);

/**
 * __useEnabledModuleCurrenciesQuery__
 *
 * To run a query within a React component, call `useEnabledModuleCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledModuleCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledModuleCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
function useEnabledModuleCurrenciesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(EnabledModuleCurrenciesDocument, options);
}
function useEnabledModuleCurrenciesLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(EnabledModuleCurrenciesDocument, options);
}
var FeedDocument = gql(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  query Feed(\n    $profileId: ProfileId!\n    $restrictEventTypesTo: [FeedEventItemType!]\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n    $metadata: PublicationMetadataFilters\n  ) {\n    result: feed(\n      request: {\n        profileId: $profileId\n        feedEventItemTypes: $restrictEventTypesTo\n        limit: $limit\n        cursor: $cursor\n        sources: $sources\n        metadata: $metadata\n      }\n    ) {\n      items {\n        ...FeedItem\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), FeedItemFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      restrictEventTypesTo: // value for 'restrictEventTypesTo'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
function useFeedQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(FeedDocument, options);
}
function useFeedLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(FeedDocument, options);
}
var ExploreProfilesDocument = gql(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  query ExploreProfiles(\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: exploreProfiles(\n      request: { limit: $limit, cursor: $cursor, sortCriteria: MOST_COMMENTS }\n    ) {\n      items {\n        ...Profile\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useExploreProfilesQuery__
 *
 * To run a query within a React component, call `useExploreProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreProfilesQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useExploreProfilesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ExploreProfilesDocument, options);
}
function useExploreProfilesLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ExploreProfilesDocument, options);
}
var CreateFollowTypedDataDocument = gql(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n  mutation CreateFollowTypedData($request: FollowRequest!, $options: TypedDataOptions) {\n    result: createFollowTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          FollowWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          profileIds\n          datas\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreateFollowTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateFollowTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowTypedDataMutation, { data, loading, error }] = useCreateFollowTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateFollowTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateFollowTypedDataDocument, options);
}
var CreateMirrorTypedDataDocument = gql(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n  mutation CreateMirrorTypedData($request: CreateMirrorRequest!, $options: TypedDataOptions) {\n    result: createMirrorTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          MirrorWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          profileIdPointed\n          pubIdPointed\n          referenceModuleData\n          referenceModule\n          referenceModuleInitData\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreateMirrorTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateMirrorTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMirrorTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMirrorTypedDataMutation, { data, loading, error }] = useCreateMirrorTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateMirrorTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateMirrorTypedDataDocument, options);
}
var CreateMirrorViaDispatcherDocument = gql(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  mutation CreateMirrorViaDispatcher($request: CreateMirrorRequest!) {\n    result: createMirrorViaDispatcher(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreateMirrorViaDispatcherMutation__
 *
 * To run a mutation, you first call `useCreateMirrorViaDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMirrorViaDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMirrorViaDispatcherMutation, { data, loading, error }] = useCreateMirrorViaDispatcherMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateMirrorViaDispatcherMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateMirrorViaDispatcherDocument, options);
}
var EnabledModulesDocument = gql(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n  query EnabledModules {\n    result: enabledModules {\n      ...EnabledModules\n    }\n  }\n  ", "\n"])), EnabledModulesFragmentDoc);

/**
 * __useEnabledModulesQuery__
 *
 * To run a query within a React component, call `useEnabledModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledModulesQuery({
 *   variables: {
 *   },
 * });
 */
function useEnabledModulesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(EnabledModulesDocument, options);
}
function useEnabledModulesLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(EnabledModulesDocument, options);
}
var NotificationsDocument = gql(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n  query Notifications(\n    $observerId: ProfileId!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n    $notificationTypes: [NotificationTypes!]\n  ) {\n    result: notifications(\n      request: {\n        profileId: $observerId\n        limit: $limit\n        cursor: $cursor\n        sources: $sources\n        notificationTypes: $notificationTypes\n      }\n    ) {\n      items {\n        ... on NewFollowerNotification {\n          ...NewFollowerNotification\n        }\n        ... on NewMirrorNotification {\n          ...NewMirrorNotification\n        }\n        ... on NewCollectNotification {\n          ...NewCollectNotification\n        }\n        ... on NewCommentNotification {\n          ...NewCommentNotification\n        }\n        ... on NewMentionNotification {\n          ...NewMentionNotification\n        }\n        ... on NewReactionNotification {\n          ...NewReactionNotification\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), NewFollowerNotificationFragmentDoc, NewMirrorNotificationFragmentDoc, NewCollectNotificationFragmentDoc, NewCommentNotificationFragmentDoc, NewMentionNotificationFragmentDoc, NewReactionNotificationFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *      notificationTypes: // value for 'notificationTypes'
 *   },
 * });
 */
function useNotificationsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(NotificationsDocument, options);
}
function useNotificationsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(NotificationsDocument, options);
}
var UnreadNotificationCountDocument = gql(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  query UnreadNotificationCount(\n    $profileId: ProfileId!\n    $sources: [Sources!]\n    $notificationTypes: [NotificationTypes!]\n  ) {\n    result: notifications(\n      request: { profileId: $profileId, sources: $sources, notificationTypes: $notificationTypes }\n    ) {\n      pageInfo {\n        totalCount\n      }\n    }\n  }\n"])));

/**
 * __useUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationCountQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      sources: // value for 'sources'
 *      notificationTypes: // value for 'notificationTypes'
 *   },
 * });
 */
function useUnreadNotificationCountQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(UnreadNotificationCountDocument, options);
}
function useUnreadNotificationCountLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(UnreadNotificationCountDocument, options);
}
var CreatePostTypedDataDocument = gql(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n  mutation CreatePostTypedData($request: CreatePublicPostRequest!, $options: TypedDataOptions) {\n    result: createPostTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          PostWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          contentURI\n          collectModule\n          collectModuleInitData\n          referenceModule\n          referenceModuleInitData\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreatePostTypedDataMutation__
 *
 * To run a mutation, you first call `useCreatePostTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostTypedDataMutation, { data, loading, error }] = useCreatePostTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreatePostTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreatePostTypedDataDocument, options);
}
var CreatePostViaDispatcherDocument = gql(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n  mutation CreatePostViaDispatcher($request: CreatePublicPostRequest!) {\n    result: createPostViaDispatcher(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreatePostViaDispatcherMutation__
 *
 * To run a mutation, you first call `useCreatePostViaDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostViaDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostViaDispatcherMutation, { data, loading, error }] = useCreatePostViaDispatcherMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreatePostViaDispatcherMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreatePostViaDispatcherDocument, options);
}
var CreateSetDispatcherTypedDataDocument = gql(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n  mutation CreateSetDispatcherTypedData(\n    $request: SetDispatcherRequest!\n    $options: TypedDataOptions\n  ) {\n    result: createSetDispatcherTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          SetDispatcherWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          name\n          chainId\n          version\n          verifyingContract\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          dispatcher\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateSetDispatcherTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateSetDispatcherTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetDispatcherTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetDispatcherTypedDataMutation, { data, loading, error }] = useCreateSetDispatcherTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateSetDispatcherTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetDispatcherTypedDataDocument, options);
}
var ProfilesToFollowDocument = gql(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n  query ProfilesToFollow($observerId: ProfileId, $sources: [Sources!]!) {\n    result: recommendedProfiles {\n      ...Profile\n    }\n  }\n  ", "\n"])), ProfileFragmentDoc);

/**
 * __useProfilesToFollowQuery__
 *
 * To run a query within a React component, call `useProfilesToFollowQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilesToFollowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilesToFollowQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useProfilesToFollowQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfilesToFollowDocument, options);
}
function useProfilesToFollowLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfilesToFollowDocument, options);
}
var GetProfileDocument = gql(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n  query GetProfile(\n    $request: SingleProfileQueryRequest!\n    $observerId: ProfileId\n    $sources: [Sources!] = []\n  ) {\n    result: profile(request: $request) {\n      ...Profile\n    }\n  }\n  ", "\n"])), ProfileFragmentDoc);

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      request: // value for 'request'
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useGetProfileQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetProfileDocument, options);
}
function useGetProfileLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetProfileDocument, options);
}
var GetAllProfilesByOwnerAddressDocument = gql(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n  query GetAllProfilesByOwnerAddress(\n    $address: EthereumAddress!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!] = []\n  ) {\n    result: profiles(request: { ownedBy: [$address], limit: $limit, cursor: $cursor }) {\n      items {\n        ...Profile\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useGetAllProfilesByOwnerAddressQuery__
 *
 * To run a query within a React component, call `useGetAllProfilesByOwnerAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProfilesByOwnerAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProfilesByOwnerAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useGetAllProfilesByOwnerAddressQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetAllProfilesByOwnerAddressDocument, options);
}
function useGetAllProfilesByOwnerAddressLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetAllProfilesByOwnerAddressDocument, options);
}
var CreateProfileDocument = gql(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n  mutation CreateProfile($request: CreateProfileRequest!) {\n    result: createProfile(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateProfileMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateProfileDocument, options);
}
var MutualFollowersProfilesDocument = gql(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n  query MutualFollowersProfiles(\n    $observerId: ProfileId!\n    $viewingProfileId: ProfileId!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: mutualFollowersProfiles(\n      request: {\n        yourProfileId: $observerId\n        viewingProfileId: $viewingProfileId\n        limit: $limit\n        cursor: $cursor\n      }\n    ) {\n      items {\n        ...Profile\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useMutualFollowersProfilesQuery__
 *
 * To run a query within a React component, call `useMutualFollowersProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutualFollowersProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutualFollowersProfilesQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      viewingProfileId: // value for 'viewingProfileId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useMutualFollowersProfilesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(MutualFollowersProfilesDocument, options);
}
function useMutualFollowersProfilesLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(MutualFollowersProfilesDocument, options);
}
var CreateSetFollowModuleTypedDataDocument = gql(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n  mutation CreateSetFollowModuleTypedData(\n    $request: CreateSetFollowModuleRequest!\n    $options: TypedDataOptions\n  ) {\n    result: createSetFollowModuleTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          SetFollowModuleWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          name\n          chainId\n          version\n          verifyingContract\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          followModule\n          followModuleInitData\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateSetFollowModuleTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateSetFollowModuleTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetFollowModuleTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetFollowModuleTypedDataMutation, { data, loading, error }] = useCreateSetFollowModuleTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateSetFollowModuleTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetFollowModuleTypedDataDocument, options);
}
var CreateSetProfileImageUriTypedDataDocument = gql(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n  mutation CreateSetProfileImageURITypedData(\n    $request: UpdateProfileImageRequest!\n    $options: TypedDataOptions\n  ) {\n    result: createSetProfileImageURITypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          SetProfileImageURIWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          name\n          chainId\n          version\n          verifyingContract\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          imageURI\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateSetProfileImageUriTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateSetProfileImageUriTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetProfileImageUriTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetProfileImageUriTypedDataMutation, { data, loading, error }] = useCreateSetProfileImageUriTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateSetProfileImageUriTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetProfileImageUriTypedDataDocument, options);
}
var CreateSetProfileImageUriViaDispatcherDocument = gql(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  mutation CreateSetProfileImageURIViaDispatcher($request: UpdateProfileImageRequest!) {\n    result: createSetProfileImageURIViaDispatcher(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreateSetProfileImageUriViaDispatcherMutation__
 *
 * To run a mutation, you first call `useCreateSetProfileImageUriViaDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetProfileImageUriViaDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetProfileImageUriViaDispatcherMutation, { data, loading, error }] = useCreateSetProfileImageUriViaDispatcherMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateSetProfileImageUriViaDispatcherMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetProfileImageUriViaDispatcherDocument, options);
}
var CreateSetProfileMetadataTypedDataDocument = gql(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n  mutation CreateSetProfileMetadataTypedData(\n    $request: CreatePublicSetProfileMetadataURIRequest!\n    $options: TypedDataOptions\n  ) {\n    result: createSetProfileMetadataTypedData(request: $request, options: $options) {\n      id\n      expiresAt\n      typedData {\n        types {\n          SetProfileMetadataURIWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          name\n          chainId\n          version\n          verifyingContract\n        }\n        value {\n          nonce\n          deadline\n          profileId\n          metadata\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateSetProfileMetadataTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateSetProfileMetadataTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetProfileMetadataTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetProfileMetadataTypedDataMutation, { data, loading, error }] = useCreateSetProfileMetadataTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *      options: // value for 'options'
 *   },
 * });
 */
function useCreateSetProfileMetadataTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetProfileMetadataTypedDataDocument, options);
}
var CreateSetProfileMetadataViaDispatcherDocument = gql(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  mutation CreateSetProfileMetadataViaDispatcher(\n    $request: CreatePublicSetProfileMetadataURIRequest!\n  ) {\n    result: createSetProfileMetadataViaDispatcher(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useCreateSetProfileMetadataViaDispatcherMutation__
 *
 * To run a mutation, you first call `useCreateSetProfileMetadataViaDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetProfileMetadataViaDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetProfileMetadataViaDispatcherMutation, { data, loading, error }] = useCreateSetProfileMetadataViaDispatcherMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateSetProfileMetadataViaDispatcherMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateSetProfileMetadataViaDispatcherDocument, options);
}
var ProfileFollowersDocument = gql(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  query ProfileFollowers(\n    $profileId: ProfileId!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $observerId: ProfileId\n    $sources: [Sources!]!\n  ) {\n    result: followers(request: { profileId: $profileId, limit: $limit, cursor: $cursor }) {\n      items {\n        ...Follower\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), FollowerFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useProfileFollowersQuery__
 *
 * To run a query within a React component, call `useProfileFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileFollowersQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useProfileFollowersQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfileFollowersDocument, options);
}
function useProfileFollowersLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfileFollowersDocument, options);
}
var ProfileFollowingDocument = gql(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n  query ProfileFollowing(\n    $walletAddress: EthereumAddress!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $observerId: ProfileId\n    $sources: [Sources!]!\n  ) {\n    result: following(request: { address: $walletAddress, limit: $limit, cursor: $cursor }) {\n      items {\n        ...Following\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), FollowingFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useProfileFollowingQuery__
 *
 * To run a query within a React component, call `useProfileFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileFollowingQuery({
 *   variables: {
 *      walletAddress: // value for 'walletAddress'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useProfileFollowingQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfileFollowingDocument, options);
}
function useProfileFollowingLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfileFollowingDocument, options);
}
var ProxyActionStatusDocument = gql(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n  query ProxyActionStatus($proxyActionId: ProxyActionId!) {\n    result: proxyActionStatus(proxyActionId: $proxyActionId) {\n      ... on ProxyActionStatusResult {\n        ...ProxyActionStatusResult\n      }\n      ... on ProxyActionError {\n        ...ProxyActionError\n      }\n      ... on ProxyActionQueued {\n        ...ProxyActionQueued\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), ProxyActionStatusResultFragmentDoc, ProxyActionErrorFragmentDoc, ProxyActionQueuedFragmentDoc);

/**
 * __useProxyActionStatusQuery__
 *
 * To run a query within a React component, call `useProxyActionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProxyActionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProxyActionStatusQuery({
 *   variables: {
 *      proxyActionId: // value for 'proxyActionId'
 *   },
 * });
 */
function useProxyActionStatusQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProxyActionStatusDocument, options);
}
function useProxyActionStatusLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProxyActionStatusDocument, options);
}
var ProxyActionDocument = gql(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n  mutation ProxyAction($request: ProxyActionRequest!) {\n    result: proxyAction(request: $request)\n  }\n"])));
/**
 * __useProxyActionMutation__
 *
 * To run a mutation, you first call `useProxyActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProxyActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proxyActionMutation, { data, loading, error }] = useProxyActionMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useProxyActionMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(ProxyActionDocument, options);
}
var PublicationDocument = gql(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n  query Publication(\n    $observerId: ProfileId\n    $publicationId: InternalPublicationId!\n    $sources: [Sources!]!\n  ) {\n    result: publication(request: { publicationId: $publicationId }) {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...Mirror\n      }\n      ... on Comment {\n        ...Comment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc);

/**
 * __usePublicationQuery__
 *
 * To run a query within a React component, call `usePublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      publicationId: // value for 'publicationId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function usePublicationQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PublicationDocument, options);
}
function usePublicationLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PublicationDocument, options);
}
var PublicationByTxHashDocument = gql(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n  query PublicationByTxHash($observerId: ProfileId, $txHash: TxHash!, $sources: [Sources!]!) {\n    result: publication(request: { txHash: $txHash }) {\n      ... on Post {\n        ...Post\n      }\n      ... on Mirror {\n        ...Mirror\n      }\n      ... on Comment {\n        ...CommentWithFirstComment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentWithFirstCommentFragmentDoc);

/**
 * __usePublicationByTxHashQuery__
 *
 * To run a query within a React component, call `usePublicationByTxHashQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationByTxHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationByTxHashQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      txHash: // value for 'txHash'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function usePublicationByTxHashQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PublicationByTxHashDocument, options);
}
function usePublicationByTxHashLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PublicationByTxHashDocument, options);
}
var HidePublicationDocument = gql(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n  mutation HidePublication($publicationId: InternalPublicationId!) {\n    hidePublication(request: { publicationId: $publicationId })\n  }\n"])));
/**
 * __useHidePublicationMutation__
 *
 * To run a mutation, you first call `useHidePublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHidePublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hidePublicationMutation, { data, loading, error }] = useHidePublicationMutation({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *   },
 * });
 */
function useHidePublicationMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(HidePublicationDocument, options);
}
var PublicationsDocument = gql(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n  query Publications(\n    $profileId: ProfileId!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $publicationTypes: [PublicationTypes!]\n    $sources: [Sources!]!\n    $metadata: PublicationMetadataFilters\n  ) {\n    result: publications(\n      request: {\n        profileId: $profileId\n        limit: $limit\n        cursor: $cursor\n        publicationTypes: $publicationTypes\n        sources: $sources\n        metadata: $metadata\n      }\n    ) {\n      items {\n        ... on Post {\n          ...Post\n        }\n        ... on Mirror {\n          ...Mirror\n        }\n        ... on Comment {\n          ...Comment\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __usePublicationsQuery__
 *
 * To run a query within a React component, call `usePublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      publicationTypes: // value for 'publicationTypes'
 *      sources: // value for 'sources'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
function usePublicationsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PublicationsDocument, options);
}
function usePublicationsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PublicationsDocument, options);
}
var ExplorePublicationsDocument = gql(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n  query ExplorePublications(\n    $cursor: Cursor\n    $excludeProfileIds: [ProfileId!]\n    $limit: LimitScalar!\n    $metadata: PublicationMetadataFilters\n    $observerId: ProfileId\n    $publicationTypes: [PublicationTypes!]\n    $sortCriteria: PublicationSortCriteria!\n    $sources: [Sources!]!\n    $timestamp: TimestampScalar\n  ) {\n    result: explorePublications(\n      request: {\n        cursor: $cursor\n        excludeProfileIds: $excludeProfileIds\n        limit: $limit\n        metadata: $metadata\n        publicationTypes: $publicationTypes\n        sortCriteria: $sortCriteria\n        sources: $sources\n        timestamp: $timestamp\n      }\n    ) {\n      items {\n        ... on Post {\n          ...Post\n        }\n        ... on Mirror {\n          ...Mirror\n        }\n        ... on Comment {\n          ...Comment\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useExplorePublicationsQuery__
 *
 * To run a query within a React component, call `useExplorePublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorePublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorePublicationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      excludeProfileIds: // value for 'excludeProfileIds'
 *      limit: // value for 'limit'
 *      metadata: // value for 'metadata'
 *      observerId: // value for 'observerId'
 *      publicationTypes: // value for 'publicationTypes'
 *      sortCriteria: // value for 'sortCriteria'
 *      sources: // value for 'sources'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
function useExplorePublicationsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ExplorePublicationsDocument, options);
}
function useExplorePublicationsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ExplorePublicationsDocument, options);
}
var WhoCollectedPublicationDocument = gql(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n  query WhoCollectedPublication(\n    $publicationId: InternalPublicationId!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: whoCollectedPublication(\n      request: { publicationId: $publicationId, limit: $limit, cursor: $cursor }\n    ) {\n      items {\n        ...Wallet\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), WalletFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useWhoCollectedPublicationQuery__
 *
 * To run a query within a React component, call `useWhoCollectedPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoCollectedPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoCollectedPublicationQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useWhoCollectedPublicationQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(WhoCollectedPublicationDocument, options);
}
function useWhoCollectedPublicationLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(WhoCollectedPublicationDocument, options);
}
var GetAllProfilesByWhoMirroredPublicationDocument = gql(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n  query GetAllProfilesByWhoMirroredPublication(\n    $publicationId: InternalPublicationId!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: profiles(\n      request: { whoMirroredPublicationId: $publicationId, limit: $limit, cursor: $cursor }\n    ) {\n      items {\n        ...Profile\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useGetAllProfilesByWhoMirroredPublicationQuery__
 *
 * To run a query within a React component, call `useGetAllProfilesByWhoMirroredPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProfilesByWhoMirroredPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProfilesByWhoMirroredPublicationQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useGetAllProfilesByWhoMirroredPublicationQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetAllProfilesByWhoMirroredPublicationDocument, options);
}
function useGetAllProfilesByWhoMirroredPublicationLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetAllProfilesByWhoMirroredPublicationDocument, options);
}
var ProfilePublicationsForSaleDocument = gql(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n  query ProfilePublicationsForSale(\n    $profileId: ProfileId!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: profilePublicationsForSale(\n      request: { profileId: $profileId, limit: $limit, cursor: $cursor, sources: $sources }\n    ) {\n      items {\n        ... on Post {\n          ...Post\n        }\n        ... on Comment {\n          ...Comment\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, CommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useProfilePublicationsForSaleQuery__
 *
 * To run a query within a React component, call `useProfilePublicationsForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePublicationsForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePublicationsForSaleQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useProfilePublicationsForSaleQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfilePublicationsForSaleDocument, options);
}
function useProfilePublicationsForSaleLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfilePublicationsForSaleDocument, options);
}
var AddReactionDocument = gql(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n  mutation AddReaction(\n    $publicationId: InternalPublicationId!\n    $reaction: ReactionTypes!\n    $profileId: ProfileId!\n  ) {\n    addReaction(\n      request: { publicationId: $publicationId, reaction: $reaction, profileId: $profileId }\n    )\n  }\n"])));
/**
 * __useAddReactionMutation__
 *
 * To run a mutation, you first call `useAddReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionMutation, { data, loading, error }] = useAddReactionMutation({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      reaction: // value for 'reaction'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
function useAddReactionMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(AddReactionDocument, options);
}
var RemoveReactionDocument = gql(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n  mutation RemoveReaction(\n    $publicationId: InternalPublicationId!\n    $reaction: ReactionTypes!\n    $profileId: ProfileId!\n  ) {\n    removeReaction(\n      request: { publicationId: $publicationId, reaction: $reaction, profileId: $profileId }\n    )\n  }\n"])));
/**
 * __useRemoveReactionMutation__
 *
 * To run a mutation, you first call `useRemoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionMutation, { data, loading, error }] = useRemoveReactionMutation({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      reaction: // value for 'reaction'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
function useRemoveReactionMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(RemoveReactionDocument, options);
}
var WhoReactedPublicationDocument = gql(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n  query WhoReactedPublication(\n    $limit: LimitScalar\n    $cursor: Cursor\n    $publicationId: InternalPublicationId!\n    $observerId: ProfileId\n    $sources: [Sources!]!\n  ) {\n    result: whoReactedPublication(\n      request: { limit: $limit, cursor: $cursor, publicationId: $publicationId }\n    ) {\n      items {\n        ...WhoReactedResult\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), WhoReactedResultFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useWhoReactedPublicationQuery__
 *
 * To run a query within a React component, call `useWhoReactedPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoReactedPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoReactedPublicationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      publicationId: // value for 'publicationId'
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useWhoReactedPublicationQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(WhoReactedPublicationDocument, options);
}
function useWhoReactedPublicationLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(WhoReactedPublicationDocument, options);
}
var ReportPublicationDocument = gql(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n  mutation ReportPublication(\n    $publicationId: InternalPublicationId!\n    $reason: ReportingReasonInputParams!\n    $additionalComments: String\n  ) {\n    reportPublication(\n      request: {\n        publicationId: $publicationId\n        reason: $reason\n        additionalComments: $additionalComments\n      }\n    )\n  }\n"])));
/**
 * __useReportPublicationMutation__
 *
 * To run a mutation, you first call `useReportPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPublicationMutation, { data, loading, error }] = useReportPublicationMutation({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      reason: // value for 'reason'
 *      additionalComments: // value for 'additionalComments'
 *   },
 * });
 */
function useReportPublicationMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(ReportPublicationDocument, options);
}
var PublicationRevenueDocument = gql(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n  query PublicationRevenue(\n    $publicationId: InternalPublicationId!\n    $observerId: ProfileId\n    $sources: [Sources!]!\n  ) {\n    result: publicationRevenue(request: { publicationId: $publicationId }) {\n      ...PublicationRevenue\n    }\n  }\n  ", "\n"])), PublicationRevenueFragmentDoc);

/**
 * __usePublicationRevenueQuery__
 *
 * To run a query within a React component, call `usePublicationRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationRevenueQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      observerId: // value for 'observerId'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function usePublicationRevenueQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PublicationRevenueDocument, options);
}
function usePublicationRevenueLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PublicationRevenueDocument, options);
}
var ProfilePublicationRevenueDocument = gql(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n  query ProfilePublicationRevenue(\n    $profileId: ProfileId!\n    $observerId: ProfileId\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $publicationTypes: [PublicationTypes!]\n    $sources: [Sources!]!\n  ) {\n    result: profilePublicationRevenue(\n      request: {\n        profileId: $profileId\n        limit: $limit\n        cursor: $cursor\n        types: $publicationTypes\n        sources: $sources\n      }\n    ) {\n      items {\n        ...PublicationRevenue\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n"])), PublicationRevenueFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useProfilePublicationRevenueQuery__
 *
 * To run a query within a React component, call `useProfilePublicationRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePublicationRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePublicationRevenueQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      observerId: // value for 'observerId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      publicationTypes: // value for 'publicationTypes'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useProfilePublicationRevenueQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfilePublicationRevenueDocument, options);
}
function useProfilePublicationRevenueLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfilePublicationRevenueDocument, options);
}
var ProfileFollowRevenueDocument = gql(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n  query ProfileFollowRevenue($profileId: ProfileId!) {\n    result: profileFollowRevenue(request: { profileId: $profileId }) {\n      ...ProfileFollowRevenue\n    }\n  }\n  ", "\n"])), ProfileFollowRevenueFragmentDoc);

/**
 * __useProfileFollowRevenueQuery__
 *
 * To run a query within a React component, call `useProfileFollowRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileFollowRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileFollowRevenueQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
function useProfileFollowRevenueQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ProfileFollowRevenueDocument, options);
}
function useProfileFollowRevenueLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ProfileFollowRevenueDocument, options);
}
var SearchPublicationsDocument = gql(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n  query SearchPublications(\n    $limit: LimitScalar\n    $cursor: Cursor\n    $query: Search!\n    $sources: [Sources!]!\n    $observerId: ProfileId\n  ) {\n    result: search(\n      request: {\n        query: $query\n        type: PUBLICATION\n        limit: $limit\n        cursor: $cursor\n        sources: $sources\n      }\n    ) {\n      ... on PublicationSearchResult {\n        __typename\n        items {\n          ... on Post {\n            ...Post\n          }\n          ... on Comment {\n            ...Comment\n          }\n        }\n        pageInfo {\n          ...CommonPaginatedResultInfo\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, CommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);
function useSearchPublicationsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(SearchPublicationsDocument, options);
}
var SearchProfilesDocument = gql(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n  query SearchProfiles(\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $query: Search!\n    $observerId: ProfileId\n    $sources: [Sources!]!\n  ) {\n    result: search(request: { query: $query, type: PROFILE, limit: $limit, cursor: $cursor }) {\n      ... on ProfileSearchResult {\n        __typename\n        items {\n          ...Profile\n        }\n        pageInfo {\n          ...CommonPaginatedResultInfo\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ProfileFragmentDoc, CommonPaginatedResultInfoFragmentDoc);
function useSearchProfilesLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(SearchProfilesDocument, options);
}
var HasTxHashBeenIndexedDocument = gql(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["\n  query HasTxHashBeenIndexed($request: HasTxHashBeenIndexedRequest!) {\n    result: hasTxHashBeenIndexed(request: $request) {\n      ... on TransactionIndexedResult {\n        ...TransactionIndexedResult\n      }\n      ... on TransactionError {\n        ...TransactionError\n      }\n    }\n  }\n  ", "\n  ", "\n"])), TransactionIndexedResultFragmentDoc, TransactionErrorFragmentDoc);

/**
 * __useHasTxHashBeenIndexedQuery__
 *
 * To run a query within a React component, call `useHasTxHashBeenIndexedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasTxHashBeenIndexedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasTxHashBeenIndexedQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useHasTxHashBeenIndexedQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(HasTxHashBeenIndexedDocument, options);
}
function useHasTxHashBeenIndexedLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(HasTxHashBeenIndexedDocument, options);
}
var BroadcastProtocolCallDocument = gql(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["\n  mutation BroadcastProtocolCall($request: BroadcastRequest!) {\n    result: broadcast(request: $request) {\n      ...RelayResult\n    }\n  }\n  ", "\n"])), RelayResultFragmentDoc);
/**
 * __useBroadcastProtocolCallMutation__
 *
 * To run a mutation, you first call `useBroadcastProtocolCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastProtocolCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastProtocolCallMutation, { data, loading, error }] = useBroadcastProtocolCallMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useBroadcastProtocolCallMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(BroadcastProtocolCallDocument, options);
}
var CreateUnfollowTypedDataDocument = gql(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\n  mutation CreateUnfollowTypedData($request: UnfollowRequest!) {\n    result: createUnfollowTypedData(request: $request) {\n      id\n      expiresAt\n      typedData {\n        types {\n          BurnWithSig {\n            name\n            type\n          }\n        }\n        domain {\n          ...EIP712TypedDataDomain\n        }\n        value {\n          nonce\n          deadline\n          tokenId\n        }\n      }\n    }\n  }\n  ", "\n"])), Eip712TypedDataDomainFragmentDoc);
/**
 * __useCreateUnfollowTypedDataMutation__
 *
 * To run a mutation, you first call `useCreateUnfollowTypedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnfollowTypedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnfollowTypedDataMutation, { data, loading, error }] = useCreateUnfollowTypedDataMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useCreateUnfollowTypedDataMutation(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useMutation(CreateUnfollowTypedDataDocument, options);
}
var WalletCollectedPublicationsDocument = gql(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["\n  query WalletCollectedPublications(\n    $observerId: ProfileId\n    $walletAddress: EthereumAddress!\n    $limit: LimitScalar!\n    $cursor: Cursor\n    $sources: [Sources!]!\n  ) {\n    result: publications(\n      request: {\n        collectedBy: $walletAddress\n        limit: $limit\n        cursor: $cursor\n        publicationTypes: [POST, COMMENT]\n        sources: $sources\n      }\n    ) {\n      items {\n        ... on Post {\n          ...Post\n        }\n        ... on Mirror {\n          ...Mirror\n        }\n        ... on Comment {\n          ...Comment\n        }\n      }\n      pageInfo {\n        ...CommonPaginatedResultInfo\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PostFragmentDoc, MirrorFragmentDoc, CommentFragmentDoc, CommonPaginatedResultInfoFragmentDoc);

/**
 * __useWalletCollectedPublicationsQuery__
 *
 * To run a query within a React component, call `useWalletCollectedPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletCollectedPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletCollectedPublicationsQuery({
 *   variables: {
 *      observerId: // value for 'observerId'
 *      walletAddress: // value for 'walletAddress'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sources: // value for 'sources'
 *   },
 * });
 */
function useWalletCollectedPublicationsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(WalletCollectedPublicationsDocument, options);
}
function useWalletCollectedPublicationsLazyQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(WalletCollectedPublicationsDocument, options);
}
var result = {
  possibleTypes: {
    CollectModule: ['AaveFeeCollectModuleSettings', 'ERC4626FeeCollectModuleSettings', 'FeeCollectModuleSettings', 'FreeCollectModuleSettings', 'LimitedFeeCollectModuleSettings', 'LimitedTimedFeeCollectModuleSettings', 'MultirecipientFeeCollectModuleSettings', 'RevertCollectModuleSettings', 'TimedFeeCollectModuleSettings', 'UnknownCollectModuleSettings'],
    FeedItemRoot: ['Comment', 'Post'],
    FollowModule: ['FeeFollowModuleSettings', 'ProfileFollowModuleSettings', 'RevertFollowModuleSettings', 'UnknownFollowModuleSettings'],
    MainPostReference: ['Mirror', 'Post'],
    MentionPublication: ['Comment', 'Post'],
    MirrorablePublication: ['Comment', 'Post'],
    Notification: ['NewCollectNotification', 'NewCommentNotification', 'NewFollowerNotification', 'NewMentionNotification', 'NewMirrorNotification', 'NewReactionNotification'],
    ProfileMedia: ['MediaSet', 'NftImage'],
    ProxyActionStatusResultUnion: ['ProxyActionError', 'ProxyActionQueued', 'ProxyActionStatusResult'],
    Publication: ['Comment', 'Mirror', 'Post'],
    PublicationForSale: ['Comment', 'Post'],
    PublicationSearchResultItem: ['Comment', 'Post'],
    ReferenceModule: ['DegreesOfSeparationReferenceModuleSettings', 'FollowOnlyReferenceModuleSettings', 'UnknownReferenceModuleSettings'],
    RelayResult: ['RelayError', 'RelayerResult'],
    SearchResult: ['ProfileSearchResult', 'PublicationSearchResult'],
    TransactionResult: ['TransactionError', 'TransactionIndexedResult']
  }
};

var createAttributeTypePolicy = function createAttributeTypePolicy() {
  return {
    keyFields: false
  };
};

// Note: Copied from apollo given it's not exposed publicly
// eslint-disable-next-line @typescript-eslint/ban-types

function cursorBasedPagination(keyArgs) {
  return {
    keyArgs: keyArgs,
    read: function read(existing, _ref) {
      var canRead = _ref.canRead;
      if (!existing) {
        return existing;
      }
      var items = existing.items,
        pageInfo = existing.pageInfo;

      // items that are not in the cache anymore (for .e.g deleted publication)
      var danglingItems = items.filter(function (item) {
        return !canRead(item);
      });
      var readRes = _objectSpread2(_objectSpread2({}, existing), {}, {
        items: items,
        pageInfo: _objectSpread2(_objectSpread2({}, pageInfo), {}, {
          // reduce total count by excluding dangling items so it won't cause a new page query
          // after item was removed from the cache (for .e.g deleted publication)
          totalCount: pageInfo.totalCount !== null ? pageInfo.totalCount - danglingItems.length : null
        })
      });
      return readRes;
    },
    merge: function merge(existing, incoming) {
      if (!existing) {
        return incoming;
      }
      var existingItems = existing.items;
      var incomingItems = incoming.items;
      return _objectSpread2(_objectSpread2({}, incoming), {}, {
        items: existingItems.concat(incomingItems),
        pageInfo: incoming.pageInfo
      });
    }
  };
}

function createExploreProfilesFieldPolicy() {
  return cursorBasedPagination([['request', ['sortCriteria', 'timestamp', 'publicationTypes', 'excludeProfileIds']]]);
}

function createExplorePublicationsFieldPolicy() {
  return cursorBasedPagination([['request', ['sortCriteria', 'timestamp', 'publicationTypes', 'excludeProfileIds', 'metadata']]]);
}

function createFeedFieldPolicy() {
  return cursorBasedPagination([['request', ['profileId', 'feedEventItemTypes', 'metadata']]]);
}

var createMediaSetTypePolicy = function createMediaSetTypePolicy() {
  return {
    keyFields: false
  };
};

var createMediaTypePolicy = function createMediaTypePolicy() {
  return {
    keyFields: false
  };
};

var createNftImageTypePolicy = function createNftImageTypePolicy() {
  return {
    keyFields: false
  };
};

function createNotificationsFieldPolicy() {
  return cursorBasedPagination(['profileId']);
}

function createProfileFollowersFieldPolicy() {
  return cursorBasedPagination([['request', ['profileId']]]);
}

function createProfileFollowingFieldPolicy() {
  return cursorBasedPagination([['request', ['address']]]);
}

function createProfilePublicationRevenueFieldPolicy() {
  return cursorBasedPagination([['request', ['profileId', 'publicationTypes', 'sources']]]);
}

function createProfilePublicationsForSaleFieldPolicy() {
  return cursorBasedPagination([['request', ['profileId', 'sources', 'metadata']]]);
}

var CollectState;
(function (CollectState) {
  CollectState["CAN_BE_COLLECTED"] = "CAN_BE_COLLECTED";
  CollectState["CANNOT_BE_COLLECTED"] = "CANNOT_BE_COLLECTED";
  CollectState["NOT_A_FOLLOWER"] = "NOT_A_FOLLOWER";
  CollectState["COLLECT_LIMIT_REACHED"] = "COLLECT_LIMIT_REACHED";
  CollectState["COLLECT_TIME_EXPIRED"] = "COLLECT_TIME_EXPIRED";
})(CollectState || (CollectState = {}));

var ProfileAttributeReader = /*#__PURE__*/function () {
  function ProfileAttributeReader(attribute) {
    _classCallCheck(this, ProfileAttributeReader);
    this.attribute = attribute;
  }
  _createClass(ProfileAttributeReader, [{
    key: "toBoolean",
    value: function toBoolean() {
      var parsed = this.jsonParse(this.attribute.value);
      if (typeof parsed === 'boolean') {
        return parsed;
      }
      return null;
    }
  }, {
    key: "toDate",
    value: function toDate() {
      var date = new Date(this.attribute.value);
      if (isNaN(date.getTime())) {
        return null;
      }
      return date;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      var parsed = this.jsonParse(this.attribute.value);
      if (typeof parsed === 'number' && isFinite(parsed)) {
        return parsed;
      }
      return null;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.attribute.value;
    }
  }, {
    key: "jsonParse",
    value: function jsonParse(value) {
      try {
        return JSON.parse(value);
      } catch (_unused) {
        return null;
      }
    }
  }]);
  return ProfileAttributeReader;
}();

function erc20Amount$1(_ref) {
  var from = _ref.from;
  var asset = erc20(_objectSpread2({
    chainType: ChainType.POLYGON
  }, from.asset));
  return Amount.erc20(asset, from.value);
}
function moduleFeeAmountParams(_ref2) {
  var from = _ref2.from;
  return {
    currency: from.asset.address,
    value: from.toFixed()
  };
}

function isProfileOwnedByMe(profile) {
  return profile.ownedByMe;
}

function isPostPublication(publication) {
  return publication.__typename === 'Post';
}
function isCommentPublication(publication) {
  return publication.__typename === 'Comment';
}
function isMirrorPublication(publication) {
  return publication.__typename === 'Mirror';
}
function getDomainReactionType(reaction) {
  switch (reaction) {
    case ReactionTypes.Upvote:
      return ReactionType.UPVOTE;
    case ReactionTypes.Downvote:
      return ReactionType.DOWNVOTE;
    default:
      never("Can't infer reaction type");
  }
}
function getApiReactionType(reaction) {
  switch (reaction) {
    case ReactionType.UPVOTE:
      return ReactionTypes.Upvote;
    case ReactionType.DOWNVOTE:
      return ReactionTypes.Downvote;
    default:
      never("Can't infer reaction type");
  }
}
function isGatedPublication(publication) {
  return publication.isGated;
}
function isContentPublication(publication) {
  return isPostPublication(publication) || isCommentPublication(publication);
}
function isPublicationOwnedByMe(publication) {
  return isProfileOwnedByMe(publication.profile);
}
function createCollectRequest(publication, collector) {
  var collectModule = publication.__typename === 'Mirror' ? publication.mirrorOf.__collectModule : publication.__collectModule;
  switch (collectModule.__typename) {
    case 'FreeCollectModuleSettings':
      return {
        profileId: collector.id,
        kind: TransactionKind.COLLECT_PUBLICATION,
        publicationId: publication.id,
        type: CollectType.FREE
      };
    case 'FeeCollectModuleSettings':
    case 'LimitedFeeCollectModuleSettings':
    case 'TimedFeeCollectModuleSettings':
    case 'LimitedTimedFeeCollectModuleSettings':
      return {
        profileId: collector.id,
        kind: TransactionKind.COLLECT_PUBLICATION,
        publicationId: publication.id,
        type: CollectType.PAID,
        fee: {
          amount: erc20Amount$1({
            from: collectModule.amount
          }),
          contractAddress: collectModule.contractAddress
        }
      };
    case 'RevertCollectModuleSettings':
    case 'UnknownCollectModuleSettings':
    case 'AaveFeeCollectModuleSettings':
    case 'ERC4626FeeCollectModuleSettings':
    case 'MultirecipientFeeCollectModuleSettings':
      never("Cannot collect publication (".concat(publication.id, ") with \"").concat(collectModule.__typename, "\" collect module"));
  }
}
function resolveTimeLimitReached(collectModule) {
  if (DateUtils.unix() > DateUtils.toUnix(collectModule.endTimestamp)) {
    return CollectState.COLLECT_TIME_EXPIRED;
  }
  return null;
}
function resolveLimitReached(collectModule, publicationStats) {
  if (publicationStats.totalAmountOfCollects >= parseInt(collectModule.collectLimit)) {
    return CollectState.COLLECT_LIMIT_REACHED;
  }
  return null;
}
function resolveNotFollower(collectModule, author) {
  if (collectModule.followerOnly && !author.__isFollowedByMe) {
    return CollectState.NOT_A_FOLLOWER;
  }
  return null;
}
function resolveCollectPolicy(_ref) {
  var _resolveNotFollower, _ref2, _resolveNotFollower2, _ref3, _resolveNotFollower3, _ref4, _ref5, _resolveNotFollower4, _resolveNotFollower5;
  var profile = _ref.profile,
    collectModule = _ref.collectModule,
    publicationStats = _ref.publicationStats;
  switch (collectModule.__typename) {
    case 'FeeCollectModuleSettings':
      return {
        type: CollectPolicyType.CHARGE,
        state: (_resolveNotFollower = resolveNotFollower(collectModule, profile)) !== null && _resolveNotFollower !== void 0 ? _resolveNotFollower : CollectState.CAN_BE_COLLECTED,
        amount: erc20Amount$1({
          from: collectModule.amount
        }),
        referralFee: collectModule.referralFee,
        followerOnly: collectModule.followerOnly
      };
    case 'LimitedFeeCollectModuleSettings':
      return {
        type: CollectPolicyType.CHARGE,
        state: (_ref2 = (_resolveNotFollower2 = resolveNotFollower(collectModule, profile)) !== null && _resolveNotFollower2 !== void 0 ? _resolveNotFollower2 : resolveLimitReached(collectModule, publicationStats)) !== null && _ref2 !== void 0 ? _ref2 : CollectState.CAN_BE_COLLECTED,
        amount: erc20Amount$1({
          from: collectModule.amount
        }),
        referralFee: collectModule.referralFee,
        collectLimit: parseInt(collectModule.collectLimit),
        followerOnly: collectModule.followerOnly
      };
    case 'TimedFeeCollectModuleSettings':
      return {
        type: CollectPolicyType.CHARGE,
        state: (_ref3 = (_resolveNotFollower3 = resolveNotFollower(collectModule, profile)) !== null && _resolveNotFollower3 !== void 0 ? _resolveNotFollower3 : resolveTimeLimitReached(collectModule)) !== null && _ref3 !== void 0 ? _ref3 : CollectState.CAN_BE_COLLECTED,
        amount: erc20Amount$1({
          from: collectModule.amount
        }),
        referralFee: collectModule.referralFee,
        endTimestamp: collectModule.endTimestamp,
        followerOnly: collectModule.followerOnly
      };
    case 'LimitedTimedFeeCollectModuleSettings':
      return {
        type: CollectPolicyType.CHARGE,
        state: (_ref4 = (_ref5 = (_resolveNotFollower4 = resolveNotFollower(collectModule, profile)) !== null && _resolveNotFollower4 !== void 0 ? _resolveNotFollower4 : resolveLimitReached(collectModule, publicationStats)) !== null && _ref5 !== void 0 ? _ref5 : resolveTimeLimitReached(collectModule)) !== null && _ref4 !== void 0 ? _ref4 : CollectState.CAN_BE_COLLECTED,
        amount: erc20Amount$1({
          from: collectModule.amount
        }),
        referralFee: collectModule.referralFee,
        collectLimit: parseInt(collectModule.collectLimit),
        endTimestamp: collectModule.endTimestamp,
        followerOnly: collectModule.followerOnly
      };
    case 'FreeCollectModuleSettings':
      return {
        type: CollectPolicyType.FREE,
        state: (_resolveNotFollower5 = resolveNotFollower(collectModule, profile)) !== null && _resolveNotFollower5 !== void 0 ? _resolveNotFollower5 : CollectState.CAN_BE_COLLECTED,
        followerOnly: collectModule.followerOnly
      };
    case 'RevertCollectModuleSettings':
    case 'AaveFeeCollectModuleSettings':
    case 'ERC4626FeeCollectModuleSettings':
    case 'MultirecipientFeeCollectModuleSettings':
    case 'UnknownCollectModuleSettings':
      return {
        type: CollectPolicyType.NO_COLLECT,
        state: CollectState.CANNOT_BE_COLLECTED
      };
  }
}

var TxStatus;
(function (TxStatus) {
  TxStatus["BROADCASTING"] = "broadcasting";
  TxStatus["MINING"] = "mining";
  TxStatus["SETTLED"] = "settled";
  TxStatus["FAILED"] = "failed";
})(TxStatus || (TxStatus = {}));
var PENDING_STATUSES = [TxStatus.BROADCASTING, TxStatus.MINING];
var recentTransactionsVar = makeVar([]);
function hasTransactionWith(transactions, statuses, predicate) {
  return transactions.some(function (txState) {
    return statuses.includes(txState.status) && predicate(txState);
  });
}
function hasPendingTransactionWith(predicate) {
  return hasTransactionWith(recentTransactionsVar(), PENDING_STATUSES, predicate);
}
function hasSettledTransactionWith(predicate) {
  return hasTransactionWith(recentTransactionsVar(), [TxStatus.SETTLED], predicate);
}
function getAllPendingTransactions() {
  return recentTransactionsVar().filter(function (txState) {
    return PENDING_STATUSES.includes(txState.status);
  });
}
function delay(waitInMs) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, waitInMs);
  });
}
function useRecentTransactionsVar() {
  return useReactiveVar(recentTransactionsVar);
}
function useHasPendingTransaction(predicate) {
  var transactions = useRecentTransactionsVar();
  return hasTransactionWith(transactions, PENDING_STATUSES, predicate);
}
var FIFTEEN_SECONDS = DateUtils.secondsToMs(30);
function useWaitUntilTransactionSettled() {
  var waitTimeInMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FIFTEEN_SECONDS;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(predicate) {
      var resolveWhenNoPendingTransactions, waitForSpecifiedTime;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resolveWhenNoPendingTransactions = new Promise(function (resolve) {
              var resolver = function resolver(value) {
                if (hasTransactionWith(value, [TxStatus.SETTLED], predicate)) {
                  return resolve();
                }
                return recentTransactionsVar.onNextChange(resolver);
              };
              recentTransactionsVar.onNextChange(resolver);
            });
            waitForSpecifiedTime = delay(waitTimeInMs).then(function () {
              // Inaccurate error, moved code over here from `@lens-protocol/react` package
              // TODO: Fix this
              throw new TransactionError(TransactionErrorReason.MINING_TIMEOUT);
            });
            _context.next = 4;
            return Promise.race([resolveWhenNoPendingTransactions, waitForSpecifiedTime]);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function isFollowTransactionFor(_ref2) {
  var profileId = _ref2.profileId,
    followerAddress = _ref2.followerAddress;
  return function (transaction) {
    return transaction.request.kind === TransactionKind.FOLLOW_PROFILES && transaction.request.profileId === profileId && transaction.request.followerAddress === followerAddress;
  };
}
function isUnfollowTransactionFor(_ref3) {
  var profileId = _ref3.profileId;
  return function (transaction) {
    return transaction.request.kind === TransactionKind.UNFOLLOW_PROFILE && transaction.request.profileId === profileId;
  };
}

function resolveFollowPolicy(_ref) {
  var followModule = _ref.followModule;
  if (followModule === null) {
    return {
      type: FollowPolicyType.ANYONE
    };
  }
  switch (followModule.__typename) {
    case 'FeeFollowModuleSettings':
      return {
        type: FollowPolicyType.CHARGE,
        amount: erc20Amount$1({
          from: followModule.amount
        }),
        recipient: followModule.recipient,
        contractAddress: followModule.contractAddress
      };
    case 'ProfileFollowModuleSettings':
      return {
        type: FollowPolicyType.ONLY_PROFILE_OWNERS,
        contractAddress: followModule.contractAddress
      };
    case 'RevertFollowModuleSettings':
      return {
        type: FollowPolicyType.NO_ONE,
        contractAddress: followModule.contractAddress
      };
    case 'UnknownFollowModuleSettings':
      return {
        type: FollowPolicyType.UNKNOWN,
        contractAddress: followModule.contractAddress
      };
  }
}
function createProfileTypePolicy(activeWalletVar) {
  return {
    fields: {
      isFollowing: {
        keyArgs: false
      },
      isFollowedByMe: {
        keyArgs: false,
        merge: function merge(_, incoming) {
          return incoming;
        }
      },
      followStatus: {
        read: function read(_, _ref2) {
          var _readField, _readField2;
          var readField = _ref2.readField;
          var activeWallet = activeWalletVar();
          if (!activeWallet) {
            return null;
          }
          var profileId = (_readField = readField('id')) !== null && _readField !== void 0 ? _readField : never('Cannot read profile id');
          var isFollowedByMe = (_readField2 = readField('isFollowedByMe')) !== null && _readField2 !== void 0 ? _readField2 : never('Cannot read profile isFollowedByMe');
          var isFollowTransactionForThisProfile = isFollowTransactionFor({
            profileId: profileId,
            followerAddress: activeWallet.address
          });
          var isUnfollowTransactionForThisProfile = isUnfollowTransactionFor({
            profileId: profileId
          });
          return getAllPendingTransactions().reduce(function (status, transaction) {
            if (isFollowTransactionForThisProfile(transaction)) {
              return {
                isFollowedByMe: true,
                canFollow: false,
                canUnfollow: false
              };
            }
            if (isUnfollowTransactionForThisProfile(transaction)) {
              return {
                isFollowedByMe: false,
                canFollow: false,
                canUnfollow: false
              };
            }
            return status;
          }, {
            isFollowedByMe: isFollowedByMe,
            canFollow: !isFollowedByMe,
            canUnfollow: isFollowedByMe
          });
        }
      },
      followPolicy: function followPolicy(existing, _ref3) {
        var readField = _ref3.readField;
        if (existing) return existing;
        var followModule = readField('followModule');
        return resolveFollowPolicy({
          followModule: followModule !== null && followModule !== void 0 ? followModule : null
        });
      },
      coverPicture: {
        merge: function merge(_, incoming) {
          return incoming;
        }
      },
      attributes: {
        merge: function merge(_, incoming) {
          return incoming;
        }
      },
      attributesMap: function attributesMap(_, _ref4) {
        var _readField3;
        var readField = _ref4.readField;
        return ((_readField3 = readField('attributes')) !== null && _readField3 !== void 0 ? _readField3 : []).reduce(function (acc, attribute) {
          acc[attribute.key] = new ProfileAttributeReader(attribute);
          return acc;
        }, {});
      },
      ownedByMe: function ownedByMe(_, _ref5) {
        var readField = _ref5.readField;
        var activeWallet = activeWalletVar();
        if (activeWallet) {
          return readField('ownedBy') === activeWallet.address;
        }
        return false;
      }
    }
  };
}

function createProfilesFieldPolicy() {
  return cursorBasedPagination([['request', ['ownedBy', 'handles', 'profilesIds', 'whoMirroredPublicationId']]]);
}

function assertQueryPublicationsArgs(args) {
  invariant(args === null || args === void 0 ? void 0 : args.request, 'Is not a query of publication args');
}
function getPublicationsId(request) {
  return JSON.stringify({
    profileId: request.profileId,
    publicationTypes: request.publicationTypes,
    commentsOf: request.commentsOf,
    collectedBy: request.collectedBy,
    metadata: request.metadata
  });
}
function createPublicationsFieldPolicy() {
  return cursorBasedPagination(function (args) {
    assertQueryPublicationsArgs(args);
    var request = args.request;
    return getPublicationsId(request);
  });
}

function createRevenueAggregateTypePolicy() {
  return {
    fields: {
      totalAmount: function totalAmount(_, _ref) {
        var _readField;
        var readField = _ref.readField;
        var total = (_readField = readField('total')) !== null && _readField !== void 0 ? _readField : never('total is null');
        return erc20Amount$1({
          from: total
        });
      }
    }
  };
}

function createSearchFieldPolicy() {
  return cursorBasedPagination([['request', ['query', 'type']]]);
}

function createWhoReactedPublicationFieldPolicy() {
  return cursorBasedPagination([['request', ['publicationId']]]);
}

function noCachedField() {
  return {
    // no arguments involved in caching this edge
    keyArgs: false
  };
}

/**
 * Use this to declare a type policy for an object that should not be normalized.
 * Non-normalized objects are embedded within their parent object in the cache.
 *
 * See https://www.apollographql.com/docs/react/caching/cache-configuration/#disabling-normalization
 *
 * @returns a TypePolicy that does not cache the result of the field
 */
function notNormalizedType(others) {
  return _objectSpread2({
    keyFields: false
  }, others);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["__typename"];
function allButPublicationAuthor(authorId) {
  return function (criterion) {
    var _criterion$profile;
    return ((_criterion$profile = criterion.profile) === null || _criterion$profile === void 0 ? void 0 : _criterion$profile.profileId) !== authorId;
  };
}
function toNftContractType(contractType) {
  switch (contractType) {
    case ContractType.Erc721:
      return NftContractType.Erc721;
    case ContractType.Erc1155:
      return NftContractType.Erc1155;
  }
  return null;
}
function nftOwnershipCriterion(_ref) {
  var chainID = _ref.chainID,
    contractAddress = _ref.contractAddress,
    contractType = _ref.contractType,
    tokenIds = _ref.tokenIds;
  var supportedNftContractType = toNftContractType(contractType);
  if (!supportedNftContractType) {
    return null;
  }
  if (tokenIds && hasAtLeastOne(tokenIds)) {
    return {
      type: DecryptionCriteriaType.NFT_OWNERSHIP,
      chainId: chainID,
      contractAddress: contractAddress,
      contractType: supportedNftContractType,
      tokenIds: tokenIds
    };
  }
  return {
    type: DecryptionCriteriaType.NFT_OWNERSHIP,
    chainId: chainID,
    contractAddress: contractAddress,
    contractType: supportedNftContractType
  };
}
function erc20Amount(_ref2) {
  var from = _ref2.from;
  var asset = erc20({
    chainType: ChainType.POLYGON,
    // temporary while BE works on returning an Erc20Amount node
    address: from.contractAddress,
    decimals: from.decimals,
    name: from.name,
    symbol: from.symbol
  });
  return Amount.erc20(asset, from.amount);
}
function toErc20Comp(operator) {
  return operator;
}
function erc20OwnershipCriterion(condition) {
  return {
    type: DecryptionCriteriaType.ERC20_OWNERSHIP,
    amount: erc20Amount({
      from: condition
    }),
    condition: toErc20Comp(condition.condition)
  };
}
function addressOwnershipCriterion(condition) {
  return {
    type: DecryptionCriteriaType.ADDRESS_OWNERSHIP,
    address: condition.address
  };
}
function profileOwnershipCriterion(condition) {
  return {
    type: DecryptionCriteriaType.PROFILE_OWNERSHIP,
    profileId: condition.profileId
  };
}
function followProfile(condition) {
  return {
    type: DecryptionCriteriaType.FOLLOW_PROFILE,
    profileId: condition.profileId
  };
}
function collectPublication(condition) {
  var _condition$publicatio;
  if (condition.thisPublication) {
    return {
      type: DecryptionCriteriaType.COLLECT_THIS_PUBLICATION
    };
  }
  return {
    type: DecryptionCriteriaType.COLLECT_PUBLICATION,
    publicationId: (_condition$publicatio = condition.publicationId) !== null && _condition$publicatio !== void 0 ? _condition$publicatio : never('Expected publicationId to be defined')
  };
}
function sanitize(_ref3) {
  _ref3.__typename;
    var accessCondition = _objectWithoutProperties(_ref3, _excluded);
  var conditions = Object.values(accessCondition).filter(isNonNullable);
  assertJustOne(conditions);
  return conditions[0];
}
function resolveSimpleCriterion(accessCondition) {
  var condition = sanitize(accessCondition);
  switch (condition.__typename) {
    case 'EoaOwnershipOutput':
      return addressOwnershipCriterion(condition);
    case 'Erc20OwnershipOutput':
      return erc20OwnershipCriterion(condition);
    case 'NftOwnershipOutput':
      return nftOwnershipCriterion(condition);
    case 'ProfileOwnershipOutput':
      return profileOwnershipCriterion(condition);
    case 'FollowConditionOutput':
      return followProfile(condition);
    case 'CollectConditionOutput':
      return collectPublication(condition);
  }
  return null;
}
function andCondition(_ref4) {
  var criteria = _ref4.criteria;
  var conditions = criteria.map(function (condition) {
    return resolveSimpleCriterion(condition);
  }).filter(isNonNullable);
  if (!hasTwoOrMore(conditions)) return null;
  return {
    type: DecryptionCriteriaType.AND,
    and: conditions
  };
}
function orCondition(_ref5) {
  var criteria = _ref5.criteria;
  var conditions = criteria.map(function (condition) {
    return resolveSimpleCriterion(condition);
  }).filter(isNonNullable);
  if (!hasTwoOrMore(conditions)) return null;
  return {
    type: DecryptionCriteriaType.OR,
    or: conditions
  };
}
function resolveRootCriterion(accessCondition) {
  var condition = sanitize(accessCondition);
  switch (condition.__typename) {
    case 'AndConditionOutput':
      return andCondition(condition);
    case 'OrConditionOutput':
      return orCondition(condition);
  }
  return resolveSimpleCriterion(accessCondition);
}
var decryptionCriteria = function decryptionCriteria(_, _ref6) {
  var _readField, _readField2, _readField3, _metadata$encryptionP;
  var canRead = _ref6.canRead,
    readField = _ref6.readField;
  var isGated = (_readField = readField('isGated')) !== null && _readField !== void 0 ? _readField : never();
  if (!isGated) return null;
  var author = (_readField2 = readField('profile')) !== null && _readField2 !== void 0 ? _readField2 : never();
  var metadata = (_readField3 = readField('metadata')) !== null && _readField3 !== void 0 ? _readField3 : never();
  invariant((_metadata$encryptionP = metadata.encryptionParams) === null || _metadata$encryptionP === void 0 ? void 0 : _metadata$encryptionP.accessCondition.or, 'Expected encryptionParams.accessCondition.or to be defined');
  invariant(canRead(author), 'Expected to be able to read publication author');
  var authorId = readField('id', author);
  var criteria = metadata.encryptionParams.accessCondition.or.criteria.filter(allButPublicationAuthor(authorId));
  assertJustOne(criteria);
  return resolveRootCriterion(criteria[0]);
};

function resolveReferencePolicy(module) {
  if (module === null) {
    return {
      type: ReferencePolicyType.ANYONE
    };
  }
  switch (module.__typename) {
    case 'DegreesOfSeparationReferenceModuleSettings':
      return {
        type: ReferencePolicyType.DEGREES_OF_SEPARATION,
        degreesOfSeparation: module.degreesOfSeparation
      };
    case 'FollowOnlyReferenceModuleSettings':
      return {
        type: ReferencePolicyType.FOLLOWERS_ONLY
      };
    case 'UnknownReferenceModuleSettings':
      return {
        type: ReferencePolicyType.UNKNOWN,
        contractAddress: module.contractAddress,
        data: module.referenceModuleReturnData
      };
  }
}
var referencePolicy = function referencePolicy(existing, _ref) {
  var readField = _ref.readField;
  if (existing) return existing;
  var module = readField('referenceModule');
  return resolveReferencePolicy(module !== null && module !== void 0 ? module : null);
};
var collectedBy = {
  merge: function merge(existing, incoming) {
    // workaround: try to retain the information even if the publication is updated in
    // cache as part of another query that does not have the collectedBy field
    return existing !== null && existing !== void 0 ? existing : incoming;
  }
};
var collectPolicy = function collectPolicy(existing, _ref2) {
  var readField = _ref2.readField;
  if (existing) return existing;
  var profile = readField('profile');
  var collectModule = readField('collectModule');
  var publicationStats = readField('stats');
  return resolveCollectPolicy({
    profile: profile,
    collectModule: collectModule,
    publicationStats: publicationStats
  });
};
var hasOptimisticCollectedByMe = function hasOptimisticCollectedByMe(existing) {
  return existing !== null && existing !== void 0 ? existing : false;
};
var isOptimisticMirroredByMe = function isOptimisticMirroredByMe(existing) {
  return existing !== null && existing !== void 0 ? existing : false;
};
function createContentPublicationTypePolicy() {
  return {
    fields: {
      referencePolicy: referencePolicy,
      mirrors: noCachedField(),
      reaction: noCachedField(),
      canComment: noCachedField(),
      canMirror: noCachedField(),
      hasCollectedByMe: noCachedField(),
      collectedBy: collectedBy,
      hasOptimisticCollectedByMe: hasOptimisticCollectedByMe,
      isOptimisticMirroredByMe: isOptimisticMirroredByMe,
      collectPolicy: collectPolicy,
      decryptionCriteria: decryptionCriteria
    }
  };
}

function createTypePolicies(_ref) {
  var activeWalletVar = _ref.activeWalletVar;
  return {
    Profile: createProfileTypePolicy(activeWalletVar),
    Post: createContentPublicationTypePolicy(),
    Comment: createContentPublicationTypePolicy(),
    FeedItem: notNormalizedType(),
    MetadataOutput: notNormalizedType(),
    PublicationStats: notNormalizedType({
      fields: {
        commentsTotal: noCachedField()
      }
    }),
    ProfileStats: notNormalizedType({
      fields: {
        commentsTotal: noCachedField(),
        postsTotal: noCachedField(),
        mirrorsTotal: noCachedField()
      }
    }),
    AccessConditionOutput: notNormalizedType(),
    EncryptionParamsOutput: notNormalizedType(),
    Attribute: createAttributeTypePolicy(),
    MediaSet: createMediaSetTypePolicy(),
    NftImage: createNftImageTypePolicy(),
    Media: createMediaTypePolicy(),
    RevenueAggregate: createRevenueAggregateTypePolicy(),
    Query: {
      fields: {
        feed: createFeedFieldPolicy(),
        exploreProfiles: createExploreProfilesFieldPolicy(),
        explorePublications: createExplorePublicationsFieldPolicy(),
        notifications: createNotificationsFieldPolicy(),
        profiles: createProfilesFieldPolicy(),
        profilePublicationsForSale: createProfilePublicationsForSaleFieldPolicy(),
        publications: createPublicationsFieldPolicy(),
        search: createSearchFieldPolicy(),
        whoReactedPublication: createWhoReactedPublicationFieldPolicy(),
        followers: createProfileFollowersFieldPolicy(),
        following: createProfileFollowingFieldPolicy(),
        profilePublicationRevenue: createProfilePublicationRevenueFieldPolicy()
      }
    }
  };
}
function createApolloCache(_ref2) {
  var activeWalletVar = _ref2.activeWalletVar;
  return new InMemoryCache({
    possibleTypes: result.possibleTypes,
    resultCaching: true,
    typePolicies: createTypePolicies({
      activeWalletVar: activeWalletVar
    })
  });
}

export { MediaFragmentDoc as $, PublicationReportingIllegalSubreason as A, PublicationReportingReason as B, CommentsDocument as C, DecryptFailReason as D, EncryptionProvider as E, FeedEventItemType as F, PublicationReportingSensitiveSubreason as G, PublicationReportingSpamSubreason as H, IdKitPhoneVerifyWebhookResultStatusType as I, PublicationSortCriteria as J, PublicationTypes as K, LensApolloClient as L, ReferenceModules as M, NotificationTypes as N, RelayErrorReasons as O, ProfileSortCriteria as P, ScalarOperator as Q, ReactionTypes as R, SearchProfilesDocument as S, TxStatus as T, UnspecifiedError as U, ValidationError as V, SearchRequestTypes as W, TagSortCriteria as X, TransactionErrorReasons as Y, WorldcoinPhoneVerifyType as Z, PublicationStatsFragmentDoc as _, SearchPublicationsDocument as a, ProxyActionErrorFragmentDoc as a$, MediaSetFragmentDoc as a0, MetadataAttributeOutputFragmentDoc as a1, NftOwnershipFragmentDoc as a2, Erc20OwnershipFragmentDoc as a3, AddressOwnershipFragmentDoc as a4, ProfileOwnershipFragmentDoc as a5, FollowConditionFragmentDoc as a6, CollectConditionFragmentDoc as a7, LeafConditionFragmentDoc as a8, OrConditionFragmentDoc as a9, CommentBaseFragmentDoc as aA, PostFragmentDoc as aB, MirrorBaseFragmentDoc as aC, CommentFragmentDoc as aD, CommentWithFirstCommentFragmentDoc as aE, CommonPaginatedResultInfoFragmentDoc as aF, PendingPostFragmentDoc as aG, Eip712TypedDataDomainFragmentDoc as aH, ElectedMirrorFragmentDoc as aI, MirrorEventFragmentDoc as aJ, CollectedEventFragmentDoc as aK, ReactionEventFragmentDoc as aL, FeedItemFragmentDoc as aM, EncryptedMediaSetFragmentDoc as aN, ModuleInfoFragmentDoc as aO, EnabledModuleFragmentDoc as aP, EnabledModulesFragmentDoc as aQ, NewFollowerNotificationFragmentDoc as aR, MirrorFragmentDoc as aS, NewCollectNotificationFragmentDoc as aT, NewMirrorNotificationFragmentDoc as aU, NewCommentNotificationFragmentDoc as aV, NewMentionNotificationFragmentDoc as aW, NewReactionNotificationFragmentDoc as aX, FollowerFragmentDoc as aY, FollowingFragmentDoc as aZ, ProxyActionStatusResultFragmentDoc as a_, AndConditionFragmentDoc as aa, AnyConditionFragmentDoc as ab, RootConditionFragmentDoc as ac, EncryptedMediaFragmentDoc as ad, EncryptedFieldsFragmentDoc as ae, EncryptionParamsFragmentDoc as af, MetadataFragmentDoc as ag, ProfileMediaFragmentDoc as ah, ProfileStatsFragmentDoc as ai, Erc20FragmentDoc as aj, ModuleFeeAmountFragmentDoc as ak, FeeFollowModuleSettingsFragmentDoc as al, ProfileFollowModuleSettingsFragmentDoc as am, RevertFollowModuleSettingsFragmentDoc as an, UnknownFollowModuleSettingsFragmentDoc as ao, AttributeFragmentDoc as ap, ProfileFragmentDoc as aq, WalletFragmentDoc as ar, FreeCollectModuleSettingsFragmentDoc as as, FeeCollectModuleSettingsFragmentDoc as at, LimitedFeeCollectModuleSettingsFragmentDoc as au, LimitedTimedFeeCollectModuleSettingsFragmentDoc as av, RevertCollectModuleSettingsFragmentDoc as aw, TimedFeeCollectModuleSettingsFragmentDoc as ax, CollectModuleFragmentDoc as ay, ReferenceModuleFragmentDoc as az, hasSettledTransactionWith as b, useGetAllProfilesByOwnerAddressLazyQuery as b$, ProxyActionQueuedFragmentDoc as b0, WhoReactedResultFragmentDoc as b1, Erc20AmountFragmentDoc as b2, RevenueAggregateFragmentDoc as b3, PublicationRevenueFragmentDoc as b4, ProfileFollowRevenueFragmentDoc as b5, RelayerResultFragmentDoc as b6, RelayErrorFragmentDoc as b7, RelayResultFragmentDoc as b8, TransactionIndexedResultFragmentDoc as b9, CreateMirrorTypedDataDocument as bA, useCreateMirrorTypedDataMutation as bB, CreateMirrorViaDispatcherDocument as bC, useCreateMirrorViaDispatcherMutation as bD, EnabledModulesDocument as bE, useEnabledModulesQuery as bF, useEnabledModulesLazyQuery as bG, NotificationsDocument as bH, useNotificationsQuery as bI, useNotificationsLazyQuery as bJ, UnreadNotificationCountDocument as bK, useUnreadNotificationCountQuery as bL, useUnreadNotificationCountLazyQuery as bM, CreatePostTypedDataDocument as bN, useCreatePostTypedDataMutation as bO, CreatePostViaDispatcherDocument as bP, useCreatePostViaDispatcherMutation as bQ, CreateSetDispatcherTypedDataDocument as bR, useCreateSetDispatcherTypedDataMutation as bS, ProfilesToFollowDocument as bT, useProfilesToFollowQuery as bU, useProfilesToFollowLazyQuery as bV, GetProfileDocument as bW, useGetProfileQuery as bX, useGetProfileLazyQuery as bY, GetAllProfilesByOwnerAddressDocument as bZ, useGetAllProfilesByOwnerAddressQuery as b_, TransactionErrorFragmentDoc as ba, AuthChallengeDocument as bb, useAuthChallengeQuery as bc, useAuthChallengeLazyQuery as bd, AuthAuthenticateDocument as be, useAuthAuthenticateMutation as bf, AuthRefreshDocument as bg, useAuthRefreshMutation as bh, CreateCollectTypedDataDocument as bi, useCreateCollectTypedDataMutation as bj, CreateCommentTypedDataDocument as bk, useCreateCommentTypedDataMutation as bl, CreateCommentViaDispatcherDocument as bm, useCreateCommentViaDispatcherMutation as bn, useCommentsLazyQuery as bo, EnabledModuleCurrenciesDocument as bp, useEnabledModuleCurrenciesQuery as bq, useEnabledModuleCurrenciesLazyQuery as br, FeedDocument as bs, useFeedQuery as bt, useFeedLazyQuery as bu, ExploreProfilesDocument as bv, useExploreProfilesQuery as bw, useExploreProfilesLazyQuery as bx, CreateFollowTypedDataDocument as by, useCreateFollowTypedDataMutation as bz, createApolloCache as c, useProfilePublicationRevenueLazyQuery as c$, CreateProfileDocument as c0, useCreateProfileMutation as c1, MutualFollowersProfilesDocument as c2, useMutualFollowersProfilesQuery as c3, useMutualFollowersProfilesLazyQuery as c4, CreateSetFollowModuleTypedDataDocument as c5, useCreateSetFollowModuleTypedDataMutation as c6, CreateSetProfileImageUriTypedDataDocument as c7, useCreateSetProfileImageUriTypedDataMutation as c8, CreateSetProfileImageUriViaDispatcherDocument as c9, usePublicationsLazyQuery as cA, ExplorePublicationsDocument as cB, useExplorePublicationsQuery as cC, useExplorePublicationsLazyQuery as cD, WhoCollectedPublicationDocument as cE, useWhoCollectedPublicationQuery as cF, useWhoCollectedPublicationLazyQuery as cG, GetAllProfilesByWhoMirroredPublicationDocument as cH, useGetAllProfilesByWhoMirroredPublicationQuery as cI, useGetAllProfilesByWhoMirroredPublicationLazyQuery as cJ, ProfilePublicationsForSaleDocument as cK, useProfilePublicationsForSaleQuery as cL, useProfilePublicationsForSaleLazyQuery as cM, AddReactionDocument as cN, useAddReactionMutation as cO, RemoveReactionDocument as cP, useRemoveReactionMutation as cQ, WhoReactedPublicationDocument as cR, useWhoReactedPublicationQuery as cS, useWhoReactedPublicationLazyQuery as cT, ReportPublicationDocument as cU, useReportPublicationMutation as cV, PublicationRevenueDocument as cW, usePublicationRevenueQuery as cX, usePublicationRevenueLazyQuery as cY, ProfilePublicationRevenueDocument as cZ, useProfilePublicationRevenueQuery as c_, useCreateSetProfileImageUriViaDispatcherMutation as ca, CreateSetProfileMetadataTypedDataDocument as cb, useCreateSetProfileMetadataTypedDataMutation as cc, CreateSetProfileMetadataViaDispatcherDocument as cd, useCreateSetProfileMetadataViaDispatcherMutation as ce, ProfileFollowersDocument as cf, useProfileFollowersQuery as cg, useProfileFollowersLazyQuery as ch, ProfileFollowingDocument as ci, useProfileFollowingQuery as cj, useProfileFollowingLazyQuery as ck, ProxyActionStatusDocument as cl, useProxyActionStatusQuery as cm, useProxyActionStatusLazyQuery as cn, ProxyActionDocument as co, useProxyActionMutation as cp, PublicationDocument as cq, usePublicationQuery as cr, usePublicationLazyQuery as cs, PublicationByTxHashDocument as ct, usePublicationByTxHashQuery as cu, usePublicationByTxHashLazyQuery as cv, HidePublicationDocument as cw, useHidePublicationMutation as cx, PublicationsDocument as cy, usePublicationsQuery as cz, useHasPendingTransaction as d, ProfileFollowRevenueDocument as d0, useProfileFollowRevenueQuery as d1, useProfileFollowRevenueLazyQuery as d2, useSearchPublicationsLazyQuery as d3, useSearchProfilesLazyQuery as d4, HasTxHashBeenIndexedDocument as d5, useHasTxHashBeenIndexedQuery as d6, useHasTxHashBeenIndexedLazyQuery as d7, BroadcastProtocolCallDocument as d8, useBroadcastProtocolCallMutation as d9, CreateUnfollowTypedDataDocument as da, useCreateUnfollowTypedDataMutation as db, WalletCollectedPublicationsDocument as dc, useWalletCollectedPublicationsQuery as dd, useWalletCollectedPublicationsLazyQuery as de, ProfileAttributeReader as df, erc20Amount$1 as dg, moduleFeeAmountParams as dh, isProfileOwnedByMe as di, isPostPublication as dj, isCommentPublication as dk, isMirrorPublication as dl, getDomainReactionType as dm, getApiReactionType as dn, isGatedPublication as dp, isContentPublication as dq, isPublicationOwnedByMe as dr, createCollectRequest as ds, resolveCollectPolicy as dt, _objectSpread2 as du, ApolloServerErrorCode as dv, useWaitUntilTransactionSettled as e, isUnfollowTransactionFor as f, getAllPendingTransactions as g, hasPendingTransactionWith as h, isFollowTransactionFor as i, CollectState as j, ClaimStatus as k, CollectModules as l, CommentOrderingTypes as m, CommentRankingFilter as n, ContractType as o, CustomFiltersTypes as p, FollowModules as q, recentTransactionsVar as r, ProxyActionStatusTypes as s, PublicationContentWarning as t, useRecentTransactionsVar as u, PublicationMainFocus as v, PublicationMediaSource as w, PublicationMetadataDisplayTypes as x, PublicationMetadataStatusType as y, PublicationReportingFraudSubreason as z };
